// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!../node_modules/primereact/resources/themes/md-dark-deeppurple/theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___, "", false, undefined, "primereact");
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
@layer tailwind-base, primereact, tailwind-utilities;
/* IMPORTANT: In "styled" mode you must add the PrimeReact Theme here. Do NOT include in "unstyled" mode */
@layer tailwind-base {
  *, ::before, ::after{
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x:  ;
    --tw-pan-y:  ;
    --tw-pinch-zoom:  ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position:  ;
    --tw-gradient-via-position:  ;
    --tw-gradient-to-position:  ;
    --tw-ordinal:  ;
    --tw-slashed-zero:  ;
    --tw-numeric-figure:  ;
    --tw-numeric-spacing:  ;
    --tw-numeric-fraction:  ;
    --tw-ring-inset:  ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgb(59 130 246 / 0.5);
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    --tw-blur:  ;
    --tw-brightness:  ;
    --tw-contrast:  ;
    --tw-grayscale:  ;
    --tw-hue-rotate:  ;
    --tw-invert:  ;
    --tw-saturate:  ;
    --tw-sepia:  ;
    --tw-drop-shadow:  ;
    --tw-backdrop-blur:  ;
    --tw-backdrop-brightness:  ;
    --tw-backdrop-contrast:  ;
    --tw-backdrop-grayscale:  ;
    --tw-backdrop-hue-rotate:  ;
    --tw-backdrop-invert:  ;
    --tw-backdrop-opacity:  ;
    --tw-backdrop-saturate:  ;
    --tw-backdrop-sepia:  ;
    --tw-contain-size:  ;
    --tw-contain-layout:  ;
    --tw-contain-paint:  ;
    --tw-contain-style:  ;
  }
  ::backdrop{
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x:  ;
    --tw-pan-y:  ;
    --tw-pinch-zoom:  ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position:  ;
    --tw-gradient-via-position:  ;
    --tw-gradient-to-position:  ;
    --tw-ordinal:  ;
    --tw-slashed-zero:  ;
    --tw-numeric-figure:  ;
    --tw-numeric-spacing:  ;
    --tw-numeric-fraction:  ;
    --tw-ring-inset:  ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgb(59 130 246 / 0.5);
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    --tw-blur:  ;
    --tw-brightness:  ;
    --tw-contrast:  ;
    --tw-grayscale:  ;
    --tw-hue-rotate:  ;
    --tw-invert:  ;
    --tw-saturate:  ;
    --tw-sepia:  ;
    --tw-drop-shadow:  ;
    --tw-backdrop-blur:  ;
    --tw-backdrop-brightness:  ;
    --tw-backdrop-contrast:  ;
    --tw-backdrop-grayscale:  ;
    --tw-backdrop-hue-rotate:  ;
    --tw-backdrop-invert:  ;
    --tw-backdrop-opacity:  ;
    --tw-backdrop-saturate:  ;
    --tw-backdrop-sepia:  ;
    --tw-contain-size:  ;
    --tw-contain-layout:  ;
    --tw-contain-paint:  ;
    --tw-contain-style:  ;
  }
  /* ! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com *//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
}
@layer tailwind-utilities {
  .container{
    width: 100%;
    margin-right: auto;
    margin-left: auto;
    padding-right: 1rem;
    padding-left: 1rem;
  }
  @media (min-width: 540px){
    .container{
      max-width: 540px;
    }
  }
  @media (min-width: 720px){
    .container{
      max-width: 720px;
    }
  }
  @media (min-width: 960px){
    .container{
      max-width: 960px;
    }
  }
  @media (min-width: 1140px){
    .container{
      max-width: 1140px;
    }
  }
  @media (min-width: 1320px){
    .container{
      max-width: 1320px;
    }
  }
  .visible{
    visibility: visible;
  }
  .static{
    position: static;
  }
  .fixed{
    position: fixed;
  }
  .absolute{
    position: absolute;
  }
  .relative{
    position: relative;
  }
  .sticky{
    position: sticky;
  }
  .z-10{
    z-index: 10;
  }
  .mx-\\[-16px\\]{
    margin-left: -16px;
    margin-right: -16px;
  }
  .mx-auto{
    margin-left: auto;
    margin-right: auto;
  }
  .my-10{
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
  }
  .-mr-9{
    margin-right: -2.25rem;
  }
  .mb-10{
    margin-bottom: 2.5rem;
  }
  .mb-20{
    margin-bottom: 5rem;
  }
  .mb-3{
    margin-bottom: 0.75rem;
  }
  .mb-4{
    margin-bottom: 1rem;
  }
  .ml-40{
    margin-left: 10rem;
  }
  .ml-\\[2px\\]{
    margin-left: 2px;
  }
  .mt-10{
    margin-top: 2.5rem;
  }
  .mt-20{
    margin-top: 5rem;
  }
  .mt-5{
    margin-top: 1.25rem;
  }
  .block{
    display: block;
  }
  .inline{
    display: inline;
  }
  .flex{
    display: flex;
  }
  .inline-flex{
    display: inline-flex;
  }
  .table{
    display: table;
  }
  .grid{
    display: grid;
  }
  .contents{
    display: contents;
  }
  .hidden{
    display: none;
  }
  .h-24{
    height: 6rem;
  }
  .h-8{
    height: 2rem;
  }
  .h-\\[calc\\(100vh-8rem\\)\\]{
    height: calc(100vh - 8rem);
  }
  .h-auto{
    height: auto;
  }
  .h-screen{
    height: 100vh;
  }
  .min-h-\\[330px\\]{
    min-height: 330px;
  }
  .min-h-\\[60px\\]{
    min-height: 60px;
  }
  .min-h-\\[65px\\]{
    min-height: 65px;
  }
  .w-1\\/3{
    width: 33.333333%;
  }
  .w-1\\/4{
    width: 25%;
  }
  .w-\\[calc\\(100vw-50px\\)\\]{
    width: calc(100vw - 50px);
  }
  .w-full{
    width: 100%;
  }
  .min-w-\\[100px\\]{
    min-width: 100px;
  }
  .min-w-\\[450px\\]{
    min-width: 450px;
  }
  .min-w-\\[50px\\]{
    min-width: 50px;
  }
  .max-w-\\[100px\\]{
    max-width: 100px;
  }
  .max-w-\\[450px\\]{
    max-width: 450px;
  }
  .max-w-\\[500px\\]{
    max-width: 500px;
  }
  .max-w-\\[65px\\]{
    max-width: 65px;
  }
  .max-w-sm{
    max-width: 24rem;
  }
  .shrink-0{
    flex-shrink: 0;
  }
  .transform{
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .resize{
    resize: both;
  }
  .flex-row{
    flex-direction: row;
  }
  .flex-col{
    flex-direction: column;
  }
  .flex-wrap{
    flex-wrap: wrap;
  }
  .content-center{
    align-content: center;
  }
  .items-center{
    align-items: center;
  }
  .justify-center{
    justify-content: center;
  }
  .justify-between{
    justify-content: space-between;
  }
  .gap-4{
    gap: 1rem;
  }
  .space-y-0\\.5 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
  }
  .space-y-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
  }
  .space-y-8 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(2rem * var(--tw-space-y-reverse));
  }
  .overflow-y-auto{
    overflow-y: auto;
  }
  .truncate{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .break-all{
    word-break: break-all;
  }
  .rounded-full{
    border-radius: 9999px;
  }
  .rounded-lg{
    border-radius: 0.5rem;
  }
  .rounded-md{
    border-radius: 0.375rem;
  }
  .rounded-xl{
    border-radius: 0.75rem;
  }
  .border{
    border-width: 1px;
  }
  .border-\\[2px\\]{
    border-width: 2px;
  }
  .border-\\[\\#262626\\]{
    --tw-border-opacity: 1;
    border-color: rgb(38 38 38 / var(--tw-border-opacity, 1));
  }
  .border-gray-950{
    --tw-border-opacity: 1;
    border-color: rgb(3 7 18 / var(--tw-border-opacity, 1));
  }
  .border-purple-200{
    --tw-border-opacity: 1;
    border-color: rgb(233 213 255 / var(--tw-border-opacity, 1));
  }
  .bg-blue-500{
    --tw-bg-opacity: 1;
    background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
  }
  .bg-cyan-500{
    --tw-bg-opacity: 1;
    background-color: rgb(6 182 212 / var(--tw-bg-opacity, 1));
  }
  .bg-orange-500{
    --tw-bg-opacity: 1;
    background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
  }
  .bg-slate-100{
    --tw-bg-opacity: 1;
    background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
  }
  .bg-slate-500{
    --tw-bg-opacity: 1;
    background-color: rgb(100 116 139 / var(--tw-bg-opacity, 1));
  }
  .bg-stone-950{
    --tw-bg-opacity: 1;
    background-color: rgb(12 10 9 / var(--tw-bg-opacity, 1));
  }
  .bg-white{
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  }
  .bg-yellow-500{
    --tw-bg-opacity: 1;
    background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1));
  }
  .p-10{
    padding: 2.5rem;
  }
  .p-12{
    padding: 3rem;
  }
  .p-2{
    padding: 0.5rem;
  }
  .p-20{
    padding: 5rem;
  }
  .p-5{
    padding: 1.25rem;
  }
  .p-6{
    padding: 1.5rem;
  }
  .p-8{
    padding: 2rem;
  }
  .px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .py-1{
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .py-8{
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  .pb-2{
    padding-bottom: 0.5rem;
  }
  .pb-20{
    padding-bottom: 5rem;
  }
  .pb-4{
    padding-bottom: 1rem;
  }
  .pt-2{
    padding-top: 0.5rem;
  }
  .pt-\\[120px\\]{
    padding-top: 120px;
  }
  .pt-\\[60px\\]{
    padding-top: 60px;
  }
  .text-left{
    text-align: left;
  }
  .text-center{
    text-align: center;
  }
  .text-right{
    text-align: right;
  }
  .text-justify{
    text-align: justify;
  }
  .text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }
  .text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
  .text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
  .text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
  .font-bold{
    font-weight: 700;
  }
  .font-medium{
    font-weight: 500;
  }
  .font-semibold{
    font-weight: 600;
  }
  .uppercase{
    text-transform: uppercase;
  }
  .capitalize{
    text-transform: capitalize;
  }
  .italic{
    font-style: italic;
  }
  .text-black{
    --tw-text-opacity: 1;
    color: rgb(0 0 0 / var(--tw-text-opacity, 1));
  }
  .text-blue-500{
    --tw-text-opacity: 1;
    color: rgb(59 130 246 / var(--tw-text-opacity, 1));
  }
  .text-gray-700{
    --tw-text-opacity: 1;
    color: rgb(55 65 81 / var(--tw-text-opacity, 1));
  }
  .text-purple-600{
    --tw-text-opacity: 1;
    color: rgb(147 51 234 / var(--tw-text-opacity, 1));
  }
  .text-red-500{
    --tw-text-opacity: 1;
    color: rgb(239 68 68 / var(--tw-text-opacity, 1));
  }
  .text-white{
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  }
  .underline{
    text-decoration-line: underline;
  }
  .shadow{
    --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
  .shadow-lg{
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
  .outline{
    outline-style: solid;
  }
  .blur{
    --tw-blur: blur(8px);
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  }
  .grayscale{
    --tw-grayscale: grayscale(100%);
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  }
  .invert{
    --tw-invert: invert(100%);
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  }
  .sepia{
    --tw-sepia: sepia(100%);
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  }
  .filter{
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  }
  .transition{
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
  }
  .ease-in-out{
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  }
  .ease-out{
    transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
}
.__header_extra_bold {
  font-family: "Inter", sans-serif !important;
  font-weight: 800 !important; /* Extra Bold */
  font-size: 54px !important; /* Set desired size */
  line-height: 1.2 !important; /* Adjust line height if needed */
  color: #ffffff; /* Example color */
}

@keyframes animationRotate {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(1turn);
  }
}
/* Add Animation */
@keyframes animatetop {
  from {
    top: -300px;
    opacity: 0;
  }
  to {
    top: 0;
    opacity: 1;
  }
}
.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

.___header_logoV2 {
  font-family: Anton !important;
  font-size: 45px !important;
  line-height: 45px !important;
  margin-right: 152px !important;
  color: #FFEE20;
}

.___header_logo {
  font-family: Anton !important;
  font-size: 22px !important;
  line-height: 45px !important;
  margin-right: 50px !important;
  color: #FFEE20;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}
.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.__main_pading {
  padding: 0 18px 130px 18px;
}

.__sub_padding {
  padding: 0 18px 18px 18px;
}

.App-link {
  color: #61dafb;
}

.link {
  color: blue;
}
.link:hover {
  text-decoration: underline;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
p {
  color: #ffffff;
  margin: 0;
}

.___seperator {
  width: 6px;
  height: 6px;
  background-color: #FFEE20;
  margin: 0 8px;
  border-radius: 50%;
}

.text-primary {
  color: #FFEE20;
}

.text-sceonday {
  color: #ffffff;
}

.text-black {
  color: #000000;
}

.capitalize {
  text-transform: capitalize;
}

.__logo_title {
  font-size: 24px !important;
  font-family: "Anton", sans-serif !important;
  color: #ffffff !important;
}

.MuiTab-iconWrapper {
  margin-bottom: 0 !important;
}

.__flex_responsive {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}
@media (max-width: 576px) {
  .__flex_responsive {
    flex-direction: column;
  }
}

.MuiButton-root,
.MuiButton-contained,
.MuiButton-outlined {
  border-radius: 25px !important;
  text-transform: capitalize !important;
  height: 36px !important;
  font-size: 12px !important;
  font-weight: 300 !important;
}
.MuiButton-root:focus,
.MuiButton-contained:focus,
.MuiButton-outlined:focus {
  outline: none !important;
}

._img_medium {
  width: 164px;
  height: 164px;
}
@media (max-width: 576px) {
  ._img_medium {
    width: 100px;
    height: 100px;
  }
}

.mx-auto {
  margin: auto;
}

.r-16 {
  border-radius: 16px;
}

.h100 {
  height: 100%;
}

.w100 {
  width: 100%;
}

.__back_cover {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  margin: auto;
  text-align: center;
  z-index: -1;
  filter: blur(3px);
  opacity: 0.7;
  height: inherit;
  margin-top: 0;
}
.__back_cover img {
  object-fit: cover;
}
.__back_cover ._cover_shadow {
  height: 60px;
  width: 100%;
  position: absolute;
  bottom: 0;
  background: transparent linear-gradient(180deg, rgba(16, 16, 15, 0) 0%, #1E1E1E 100%) 0% 0% no-repeat padding-box;
}
@media (max-width: 576px) {
  .__back_cover {
    width: 140vw;
  }
}
@media (min-width: 600px) and (max-width: 900px) {
  .__back_cover {
    width: 80vw;
  }
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.pr18 {
  padding-right: 18px;
}

.text-left {
  text-align: left;
}

.p-10 {
  padding: 10px;
}

.p-16 {
  padding: 16px;
}

.__small_icon {
  font-size: 12px !important;
  background: #4e4e4e;
  border-radius: 50%;
  justify-content: center;
  padding: 2px;
}

._cp {
  cursor: pointer !important;
}

._cd {
  cursor: default !important;
}

.breakWord {
  word-break: break-word;
}

.__profile_grid {
  width: initial;
  margin: auto;
  display: grid;
  grid-template-columns: auto auto;
}
@media screen and (min-width: 2400px) {
  .__profile_grid {
    grid-template-columns: auto auto auto auto;
  }
}
@media only screen and (min-width: 2000px) and (max-width: 2400px) {
  .__profile_grid {
    grid-template-columns: auto auto auto;
  }
}
@media screen and (max-width: 1800px) {
  .__profile_grid {
    grid-template-columns: auto auto;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1200px) {
  .__profile_grid {
    grid-template-columns: auto auto;
  }
}
@media only screen and (min-width: 576px) and (max-width: 991px) {
  .__profile_grid {
    grid-template-columns: auto;
  }
}
@media screen and (max-width: 576px) {
  .__profile_grid {
    grid-template-columns: auto;
  }
}

.__moonpay {
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  max-width: 400px;
  background: #ffffff;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0 auto;
  padding: 5px;
}

.mb-20 {
  margin-bottom: 20px !important;
}

.mb-10 {
  margin-bottom: 10px !important;
}

.mb-15 {
  margin-bottom: 15px !important;
}

.mt-10 {
  margin-top: 10px !important;
}

.mt-20 {
  margin-top: 20px !important;
}

.mt-30 {
  margin-top: 30px !important;
}

.MuiSlider-root {
  padding: 0 !important;
}

.fade-text {
  color: rgba(255, 255, 255, 0.4392156863) !important;
}

.fade-text-60 {
  color: rgba(255, 255, 255, 0.8) !important;
}

.text-dark {
  color: #1e1e1e !important;
}

.light-text {
  color: rgba(255, 255, 255, 0.7960784314);
}

._bb {
  border-bottom: 1px solid #e5e5e5;
}

.fade-text80 {
  color: rgba(255, 255, 255, 0.5019607843);
}

.fade-text50 {
  color: rgba(255, 255, 255, 0.3137254902);
}

.text-white {
  color: #ffffff;
}

.underline {
  text-decoration: underline;
}

.text-capitalize {
  text-transform: capitalize;
}

.fw-b {
  font-weight: bold !important;
}

.upper {
  text-transform: uppercase;
}

.MuiButton-endIcon {
  margin-left: 0;
}

.ml_auto {
  margin-left: auto !important;
}

.mr_auto {
  margin-right: auto !important;
}

.success {
  color: #05c95f;
}

.online {
  color: #2CF488;
}

.error {
  color: #e3293e !important;
}

.other {
  color: rgba(255, 255, 255, 0.3137254902);
}

.canceled {
  color: #FFEE20;
}

.bg_primary {
  background-color: #FFEE20;
}

.fs-9 {
  font-size: 9px !important;
}

.fs-10 {
  font-size: 10px !important;
}

.fs-11 {
  font-size: 11px !important;
}

.fs-11-5 {
  font-size: 11.5px !important;
}

.fs-12 {
  font-size: 12px !important;
}

.fs-13 {
  font-size: 13px !important;
}

.fs-14 {
  font-size: 14px !important;
}
@media (max-width: 576px) {
  .fs-14 {
    font-size: 12px !important;
  }
}

.fs-15 {
  font-size: 15px !important;
}
@media (max-width: 576px) {
  .fs-15 {
    font-size: 13px !important;
  }
}

.fs-17 {
  font-size: 17px !important;
}

.fs-18 {
  font-size: 18px !important;
}
@media (max-width: 576px) {
  .fs-18 {
    font-size: 16px !important;
  }
}

.fs-20 {
  font-size: 20px !important;
}
@media (max-width: 576px) {
  .fs-20 {
    font-size: 18px !important;
  }
}

.fs-24 {
  font-size: 24px !important;
}
@media (max-width: 576px) {
  .fs-24 {
    font-size: 20px !important;
  }
}

.fs-30 {
  font-size: 30px !important;
}
@media (max-width: 576px) {
  .fs-30 {
    font-size: 26px !important;
  }
}

.grid {
  display: grid;
  gap: 10px;
}
@media (max-width: 576px) {
  .grid {
    grid-template-columns: auto;
  }
}
@media (min-width: 768px) {
  .grid {
    grid-template-columns: auto auto;
  }
}
@media (min-width: 992px) {
  .grid {
    grid-template-columns: auto auto auto auto;
  }
}

.avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
}
@media (max-width: 576px) {
  .avatar {
    width: 30px !important;
    height: 30px !important;
  }
}

.avatar-sm {
  width: 28px !important;
  height: 28px !important;
  border-radius: 50%;
}

.PrivateSwipeArea-root {
  width: 0 !important;
}

.MuiOutlinedInput-root {
  border-radius: 30px !important;
}

.test-width {
  width: 100%;
}
@media (max-width: 576px) {
  .test-width {
    width: 65%;
  }
}

.b-white {
  border: 1px solid #ffffff !important;
}

.br-50 {
  border-radius: 50% !important;
}

.br-25 {
  border-radius: 25px !important;
}

.br16 {
  border-radius: 16px !important;
}

.p2 {
  padding: 2px;
}

.__home {
  position: relative;
  height: 78vh;
  overflow: scroll;
}

.__home_no_player {
  position: relative;
  height: 85vh;
  overflow: scroll;
}

.__player_image {
  width: 306px;
  height: 306px;
  border-radius: 16px;
  object-fit: cover;
}

.__upload_inputbox {
  margin-top: 7px !important;
  position: relative !important;
}
.__upload_inputbox .__input {
  border-radius: 25px !important;
  height: 50px !important;
  background-color: #262626 !important;
  display: flex;
  align-items: center;
  padding-left: 12px;
  color: rgba(255, 255, 255, 0.3137254902);
}
.__upload_inputbox .__input fieldset {
  border-color: #262626 !important;
}
.__upload_inputbox .__input .__selectedImg {
  height: 100%;
  border-radius: 50%;
  width: 42px;
  height: 42px;
}
.__upload_inputbox .__input_filled {
  color: #ffffff;
}
.__upload_inputbox .__input_area {
  border-radius: 25px !important;
  background-color: #171515 !important;
}
.__upload_inputbox .__input_area fieldset {
  border-color: #262626 !important;
}
.__upload_inputbox .__input_icon {
  position: absolute;
  right: 24px;
  top: 11px;
}

.badgeSize {
  width: 100%;
  height: 100%;
}

.avgLevel {
  position: absolute !important;
  top: 40px !important;
  left: 8px !important;
  right: 0 !important;
  bottom: 0 !important;
  margin: auto !important;
  color: #ffffff !important;
  font-size: 40px !important;
  font-weight: bold !important;
}

.social-box {
  background: #262626;
  border-radius: 25px;
  padding: 4px 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}

#gender_border,
#age_border, #género_border, #años_border, #Пол_border, #возраст_border {
  fill: transparent !important;
}

.flex-responsive {
  justify-content: flex-start;
}

.__assets__ {
  width: 210px;
  height: 210px;
  object-fit: cover;
  border-radius: 6px;
}
@media (max-width: 576px) {
  .__assets__ {
    width: 96px;
    height: 96px;
  }
}

.__assets_container__ {
  padding: 0 24px 100px 24px;
}
@media (max-width: 576px) {
  .__assets_container__ {
    padding: 0 10px 100px 10px;
  }
}
.__assets_container__ .__asset_col {
  width: 210px;
  cursor: pointer;
  position: relative;
}
@media (max-width: 576px) {
  .__assets_container__ .__asset_col {
    width: 96px;
  }
}
.__assets_container__ .__asset_col .__asset_hover {
  display: none;
  align-items: center;
  width: max-content;
  height: 38px;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  margin: auto;
}
.__assets_container__ .__asset_col:hover .__asset_hover {
  display: flex;
}
@media (max-width: 576px) {
  .__assets_container__ .__asset_col:hover .__asset_hover {
    width: 96px;
    height: 96px;
  }
}

.__private {
  background: #4e4e4e !important;
  color: #989898 !important;
  width: 12px;
  height: 12px;
  padding: 4px;
}

.__card_container {
  display: flex;
  flex-direction: row !important;
  flex-wrap: wrap;
  gap: 20px;
}
.__card_container .__card_widget {
  width: 210px;
  cursor: pointer;
}
@media (max-width: 576px) {
  .__card_container .__card_widget {
    width: 96px;
  }
}
.__card_container .__card_widget .__card_widget_image {
  object-fit: cover;
  width: 210px;
  height: 210px;
  border-radius: 6px;
}
@media (max-width: 576px) {
  .__card_container .__card_widget .__card_widget_image {
    width: 96px;
    height: 96px;
  }
}
.__music_thumb {
  position: relative;
}
.__music_thumb .__play_hover {
  display: none;
}
.__music_thumb:hover .__play_hover {
  display: block;
  width: 25px;
  position: absolute;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}

.__volume_button {
  color: #ffffff;
}
.__volume_button:hover {
  color: rgba(255, 255, 255, 0.4392156863);
}

.__volume_active {
  color: #FFEE20;
}

.__volume {
  position: absolute;
  top: -118px;
  left: 10px;
  height: 75px;
  padding: 10px 0;
  border-radius: 12px;
  width: 24px;
  background: #262626;
  display: flex;
  align-items: center;
  justify-content: center;
}

.__player_queue {
  position: absolute;
  bottom: 60px;
  right: 0;
  width: 400px;
  min-height: 400px;
  background: #171515;
  overflow: scroll;
}
@media (max-width: 576px) {
  .__player_queue {
    width: 250px;
  }
}

.nowrap {
  white-space: nowrap;
}

.__more_hover {
  background: rgba(255, 255, 255, 0.368627451) !important;
  width: 30px;
  height: 30px;
}
@media (max-width: 576px) {
  .__more_hover {
    width: 20px !important;
    height: 20px !important;
  }
}

.__more_hover_color {
  color: rgba(255, 255, 255, 0.5647058824) !important;
}
.__more_hover_color:hover {
  color: #ffffff !important;
}

.__profile_card {
  min-width: 400px;
}
@media screen and (min-width: 992px) and (max-width: 1200px) {
  .__profile_card {
    max-width: 340px !important;
    min-width: 320px;
  }
}
@media screen and (max-width: 992px) {
  .__profile_card {
    max-width: unset !important;
    min-width: 320px;
  }
}
@media screen and (min-width: 576px) and (max-width: 991px) {
  .__profile_card {
    max-width: initial !important;
  }
}
.__profile_card:hover {
  background: #1a1a1a;
}

.__level_graph {
  background-image: linear-gradient(180deg, rgba(5, 201, 95, 0.2509803922), rgba(59, 240, 5, 0.2509803922));
  border-radius: 3px !important;
  width: 8px !important;
  height: 12px !important;
  padding: 1.5px !important;
  color: #ffffff;
}
@media screen and (min-width: 992px) and (max-width: 1200px) {
  .__level_graph {
    width: 3px !important;
  }
}

.__level_graph1 {
  background-image: linear-gradient(180deg, #05c95f, #3bf005);
  color: #3bf005;
  border-radius: 3px !important;
  width: 10px !important;
  height: 15px !important;
  padding: 1.5px !important;
}
@media screen and (min-width: 992px) and (max-width: 1200px) {
  .__level_graph1 {
    width: 3px !important;
  }
}

.__level_graph2 {
  background: #4e6257;
  color: #4e6257;
  border-radius: 3px !important;
  width: 8px !important;
  height: 12px !important;
  padding: 1.5px !important;
}
@media screen and (min-width: 992px) and (max-width: 1200px) {
  .__level_graph2 {
    width: 3px !important;
  }
}

.__edit_profile_button {
  cursor: pointer;
  position: absolute !important;
  width: 97px !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  height: 36px !important;
  right: 24px !important;
  top: 24px !important;
}
.__edit_profile_button:hover {
  background-color: #FFEE20 !important;
  color: #1e1e1e !important;
}

.__update_prfofile_box {
  width: 50%;
  margin: auto;
  padding: 50px 117px;
  background: #090909;
}
@media (max-width: 576px) {
  .__update_prfofile_box {
    width: 90%;
    padding: 10px;
  }
}

.__back {
  position: absolute;
  z-index: 1;
  top: 10px;
  left: 10px;
}

.__br {
  border-right: 1px solid #929292;
  padding: 0 7px 0px 0px;
}

.web_header {
  margin: 0 18px !important;
  padding-bottom: 5px !important;
  border-bottom: 1px solid #262626 !important;
}

.faded {
  color: #999999;
}

.w24 {
  width: 24px !important;
}

.h24 {
  height: 24px !important;
}

.text-justify {
  text-align: justify;
}

.mt-5 {
  margin-top: 5px !important;
}

.my-10 {
  margin: 10px 0 !important;
}

.ml-40 {
  margin-left: 40px !important;
}

.text-center {
  text-align: center;
}

.__add_balance_tab {
  width: 30%;
  margin: auto;
}
@media (max-width: 576px) {
  .__add_balance_tab {
    width: 100%;
    padding: 0 0 100px 0;
  }
}
.__add_balance_tab .__balance_row {
  height: 50px;
  background: #090909;
  align-items: center;
  padding: 0 10px;
  border-radius: 8px;
  cursor: pointer;
}

.transform180 {
  transform: rotate(180deg);
}

.__Search_result_box {
  z-index: 2;
  background: #171515;
  position: absolute;
  top: 50px;
  width: 100%;
}

.__artist_thumbnail .__large_avatar {
  width: 210px;
  height: 210px;
  border-radius: 50%;
}
@media (max-width: 576px) {
  .__artist_thumbnail .__large_avatar {
    width: 96px;
    height: 96px;
  }
}
.__artist_thumbnail .__play_hover_artist {
  display: none;
}
.__artist_thumbnail:hover .__play_hover_artist {
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  margin: auto;
  width: 44px;
}

.MuiOutlinedInput-root #_search_icon {
  height: 100% !important;
  border-color: rgba(103, 103, 103, 0.3019607843) !important;
}
.MuiOutlinedInput-root #search-input {
  height: 100% !important;
  padding: 0 !important;
  border-color: rgba(103, 103, 103, 0.3019607843) !important;
  border-radius: 25px !important;
}
.MuiOutlinedInput-root:hover {
  background-color: #000000 !important;
  border-radius: 25px !important;
}
.MuiOutlinedInput-root:hover #_search_icon {
  border-color: #000000 !important;
  outline: #000000 !important;
  background-color: #000000 !important;
}
.MuiOutlinedInput-root:hover #search-input {
  border-color: #000000 !important;
  outline: #000000 !important;
  background-color: #000000 !important;
}

.__selectedImg {
  height: 100% !important;
  width: 100% !important;
  object-fit: contain !important;
  border-radius: 25px !important;
}

.w50_responsive {
  width: 50%;
}
@media (max-width: 576px) {
  .w50_responsive {
    width: 100%;
  }
}

.__0 {
  border-left: 1px solid #707070;
  padding-left: 6px;
  font-size: 18px;
  transition: transform 1s;
}

.__180 {
  transform: rotate(180deg);
  border-right: 1px solid #000000;
  padding-right: 6px;
  font-size: 18px;
}

.__underline_hover:hover {
  text-decoration: underline;
}

.__buy_bid_info {
  position: absolute;
  top: -35px;
  right: 30px;
  background: #262626;
  width: 45%;
}

.__hover_button {
  font-weight: 400 !important;
  height: 36px !important;
}
.__hover_button:hover {
  background-color: #FFEE20 !important;
  border-color: #FFEE20 !important;
  color: #000000 !important;
}

._responsive_flex {
  display: flex;
  width: 100%;
  flex-direction: row !important;
}
@media (max-width: 576px) {
  ._responsive_flex {
    flex-direction: column !important;
  }
}

.__responsive_playlist_statics_card {
  width: 272px !important;
}
@media (max-width: 576px) {
  .__responsive_playlist_statics_card {
    width: inherit !important;
  }
}
@media (min-width: 1600px) and (max-width: 3000px) {
  .__responsive_playlist_statics_card {
    width: inherit !important;
  }
}

.__custom_dropdown_container,
._playlist_topfive_dropdown_container {
  height: 50px;
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #171515;
  border-radius: 25px;
  cursor: pointer;
}
.__custom_dropdown_container .__transform,
._playlist_topfive_dropdown_container .__transform {
  transition: all 0.5s;
  transform: rotate(0deg);
}
.__custom_dropdown_container .__custom_dropdown,
._playlist_topfive_dropdown_container .__custom_dropdown {
  position: absolute;
  top: 50px;
  max-height: 200px;
  overflow: scroll;
  z-index: 1;
  background: #171515;
  padding: 0px 16px;
  border-radius: 0 0 25px 25px;
  width: -webkit-fill-available;
}
.__custom_dropdown_container .__custom_dropdown .__custom_dropdown_item,
._playlist_topfive_dropdown_container .__custom_dropdown .__custom_dropdown_item {
  padding: 10px 5px;
  border-bottom: 1px solid #e5e5e5;
}
.__custom_dropdown_container .__custom_dropdown .__custom_dropdown_item:hover,
._playlist_topfive_dropdown_container .__custom_dropdown .__custom_dropdown_item:hover {
  background-color: #10100f;
}

._playlist_topfive_dropdown_container {
  height: 30px !important;
}
._playlist_topfive_dropdown_container .__custom_dropdown {
  top: 30px;
}

._show_dropdown {
  border-radius: 25px 25px 0px 0px !important;
}
._show_dropdown .__transform {
  transform: rotateZ(180deg) !important;
}

.responsive-flex {
  display: flex;
}
@media (max-width: 576px) {
  .responsive-flex {
    flex-direction: column !important;
  }
  .responsive-flex ._flex_width {
    width: auto !important;
  }
  .__header_left_items {
    margin-left: auto !important;
  }
  ._display_none {
    display: none !important;
  }
}

.responsive_margin_100 {
  margin-left: 100px;
}
@media (max-width: 576px) {
  .responsive_margin_100 {
    margin-left: 0 !important;
  }
}

.__player_queue_image ._play_queue_play {
  display: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: 20px;
}
.__player_queue_image:hover ._play_queue_play {
  display: block;
}

.__tip_gradiant {
  background: linear-gradient(to right, #FFEE20, #ffb715, #ff1cbe, #00c3fd);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.__responsive_play {
  width: 30px;
  height: 30px;
}
@media (max-width: 576px) {
  .__responsive_play {
    width: 20px !important;
    height: 20px !important;
  }
}
.__responsive_play .__more_icon {
  font-size: 30px !important;
  background: rgba(255, 255, 255, 0.368627451) !important;
  border-radius: 50% !important;
}

.is-sticky {
  top: 0;
  left: 0;
  width: 90% 100;
  z-index: 1;
  padding: 38px 18px 5px;
  background: rgba(0, 0, 0, 0.3);
  -webkit-backdrop-filter: blur(30px);
  backdrop-filter: blur(45px);
  box-shadow: inset 0px -25px 20px 10px rgba(0, 0, 0, 0.75);
}

.__playlistNft_music {
  padding: 5px 10px;
  margin: 5px 10px;
  border-bottom: 1px solid #1E1E1E;
  cursor: pointer;
}
.__playlistNft_music .__playlistNft_music_back {
  display: none;
  transform: rotate(180deg);
  width: 8px;
  margin-left: auto;
  transition: display 0.2s;
}
.__playlistNft_music:hover {
  background: #000000 !important;
}
.__playlistNft_music:hover .__playlistNft_music_back {
  display: block;
}

.pos_r {
  position: relative;
}

._position_relative {
  position: relative;
}

.__chat_icon_container {
  cursor: pointer;
  position: absolute;
  right: 0;
  top: 4%;
  width: 48px;
  height: 48px;
  background: #4e4949;
  border-radius: 30px 0 0 30px;
}
.__chat_icon_container .__chat_icon {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}

._chat_online {
  position: absolute;
  right: 15px;
  top: 11px;
}

.emoji-picker-react {
  position: absolute !important;
  bottom: 60px !important;
  box-shadow: none !important;
}

._chat_opened_music {
  width: 80%;
  transition: width 0.2s ease-in-out;
}

._chat_open {
  display: flex !important;
  flex-direction: row !important;
}
@media (max-width: 576px) {
  ._chat_open {
    position: relative;
  }
}
._chat_open ._chat_opened_music {
  width: 80%;
}
@media (max-width: 576px) {
  ._chat_open ._chat_opened_music {
    width: 100%;
  }
}
._chat_open .__chat_container {
  width: 100%;
  height: 100%;
  right: 0;
}
@media (max-width: 576px) {
  ._chat_open .__chat_container {
    width: 100%;
  }
}
._chat_open .__chat_container_with_song {
  height: calc(100% - 55px);
}

.__chat_container_with_song_artist {
  bottom: 70px !important;
}

.__chat_container_without_song_artist {
  bottom: 0px !important;
}

.ls2-2 {
  letter-spacing: 2.2px !important;
}

._chat_from {
  background: #2C2C2C;
  padding: 7px;
  border-radius: 6px 6px 0;
  word-break: break-word !important;
}

._chat_to {
  background: #2C2C2C;
  padding: 7px;
  border-radius: 6px 6px 6px 0;
  word-break: break-word !important;
}

._anton {
  font-family: Anton !important;
}

._img_large {
  width: 229px;
  height: 229px;
}

.noScroll {
  overflow: unset !important;
}

._line_through {
  text-decoration-line: line-through;
  text-decoration-color: #FFEE20;
  text-decoration-thickness: 2px;
}

._lock_hover:hover {
  color: #fff;
}

.__play_all:hover {
  background-color: #FFEE20 !important;
  border-color: #FFEE20 !important;
  color: #1E1E1E !important;
}
.__play_all:hover .__play_all_play {
  color: #1E1E1E !important;
}

.white-secondary {
  color: #D5D5D5;
}

.__icon_button {
  border: 1px solid #FFFFFF !important;
  box-shadow: 0px 3px 6px rgba(118, 57, 5, 0.1411764706);
}

._pre_space {
  white-space: pre;
}

.faded-round-border {
  border: 1px solid #999999;
  border-radius: 50%;
}

.-mr-9 {
  margin-right: -9px;
}

._stream_msg {
  background: rgba(44, 44, 44, 0.3137254902);
  box-shadow: 0px 7px 6px rgba(0, 0, 0, 0.0196078431);
}

.__polygon_img {
  width: 36px;
  border: 1px solid #fff;
  border-radius: 50%;
  padding: 8px;
}

@keyframes slidein {
  from {
    margin-left: 100%;
  }
  to {
    margin-left: 0%;
  }
}
.__audience_tip {
  width: 108px;
  height: 108px;
  position: absolute;
  top: 0;
}
.__audience_tip:hover {
  background: rgba(30, 30, 30, 0.7607843137);
  cursor: pointer;
}
.__audience_tip:hover .__audience_tip_icon {
  display: block;
}
.__audience_tip .__audience_tip_icon {
  display: none;
  width: 32px;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  transition: all 0.2s;
}

.agora_video_player {
  object-fit: contain !important;
}

#cohost_video_box {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  overflow-y: scroll;
  background: #000;
  gap: 0.5rem;
}
@media (max-width: 576px) {
  #cohost_video_box {
    gap: 0.5rem;
    grid-row: 1;
    justify-content: flex-start;
    flex-direction: row;
  }
}

._un_pin_ {
  min-width: 160px !important;
  min-height: 160px !important;
  width: 160px !important;
  height: 160px !important;
  position: relative;
}
@media (max-width: 576px) {
  ._un_pin_ {
    overflow: scroll;
  }
}
._un_pin_ .agora_video_player {
  scale: 1.5 !important;
}
._un_pin_ ._pin_class {
  display: none;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  width: 24px;
  height: 24px;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  z-index: 10000;
}
._un_pin_:hover ._pin_class {
  display: block;
}

._pin_ {
  width: 100% !important;
  height: 100% !important;
  position: relative;
}
._pin_ ._pin_class {
  display: none;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  width: 24px;
  height: 24px;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}
._pin_:hover ._pin_class {
  display: none;
}

._speaking {
  width: 28px;
  height: 28px;
  position: absolute;
  top: 2px;
  right: 2px;
  border-radius: 50%;
  z-index: 10000;
}

@media (max-width: 576px) {
  #_share_screen_btn {
    display: none;
  }
  ._playlist_streaming_camera {
    position: absolute !important;
    right: 0;
    top: -41px;
  }
  .streaming_control_box_audience {
    position: fixed !important;
    right: 10px !important;
    top: 0px !important;
    z-index: 1;
    height: 42px;
  }
}

.taptostart {
  width: 28px;
  height: 28px;
  position: absolute;
  top: 8px;
  right: 46px;
  border: 2px solid #ffffff;
  z-index: 10000;
  cursor: pointer;
}

._copy_artist {
  position: absolute !important;
  z-index: 1;
  top: 10px;
  right: 10px;
}

._copy_artist_edit {
  position: absolute !important;
  z-index: 1;
  top: 24px;
  right: 126px;
}

._webview_streaming {
  width: 100% !important;
  height: 100% !important;
  margin: 0 !important;
}

._new_raised_dot {
  color: #E3293E;
  position: absolute;
  top: -5px;
  border-radius: 50%;
  font-size: 14px !important;
}

._upload_video {
  position: absolute !important;
  z-index: 1;
  top: 27px;
  right: 220px;
}
._upload_video input {
  width: 0px;
  transition: width 0.2s ease-in-out;
}

._share_url {
  top: 0 !important;
  width: 98% !important;
  height: calc(100vh - 100px) !important;
}

._upload_video_box {
  height: 40px;
  top: 24px !important;
}
._upload_video_box textarea {
  width: 444px;
  height: 32px;
  font-size: 14px;
  margin-right: 70px;
}

.MuiMenu-paper {
  background: #1e1e1e !important;
  bottom: 80px !important;
  right: 14px !important;
  top: unset !important;
  width: fit-content !important;
}

.__chat_typing_streaming {
  position: absolute;
  bottom: 50px;
}
.__chat_typing_streaming .__typing {
  color: #BDBDBD;
  font-style: italic;
  font-size: 12px;
}

._profile_alignment {
  padding: 0 100px;
  padding-top: 66px;
}
@media (max-width: 1200px) {
  ._profile_alignment {
    padding: 0 30px;
    padding-top: 66px;
  }
}
@media (max-width: 992px) {
  ._profile_alignment {
    padding: 0 30px;
    padding-top: 66px;
  }
}

._object-cover {
  object-fit: cover;
}

._nft_list_gift_card {
  width: 210px;
  height: 230px;
  border: 1px solid #707070;
  background: #000;
  border-radius: 6px;
}
@media (max-width: 576px) {
  ._nft_list_gift_card {
    width: 100%;
  }
}
._nft_list_gift_card img {
  width: 100%;
  border-radius: 6px;
}

._nft_list_gift_card_playlist {
  width: 210px;
  height: 210px;
  border: 1px solid #707070;
  background: #000;
  border-radius: 6px;
}
@media (max-width: 576px) {
  ._nft_list_gift_card_playlist {
    width: 100%;
    height: 96px;
  }
}
._nft_list_gift_card_playlist img {
  width: 100%;
  border-radius: 6px;
}

.p5 {
  padding: 5px;
}

.text-left {
  text-align: left;
}

.white-space-pre {
  white-space: pre;
}

._generateButton {
  height: fit-content !important;
  width: max-content;
  line-height: inherit !important;
}

@media (min-width: 576px) and (max-width: 800px) {
  ._responsive_row {
    display: flex !important;
    flex-direction: column !important;
  }
  ._responsive_row ._generateButton {
    max-width: 150px !important;
    height: 30px !important;
    font-size: 14px !important;
  }
}

.__follow_container {
  width: 75%;
}
@media screen and (max-width: 820px) and (min-width: 576px) {
  .__follow_container {
    width: 100%;
  }
}
@media (max-width: 576px) {
  .__follow_container {
    width: 100%;
  }
}

._small_icons {
  height: 20px;
  width: 20px;
}

._song_row_music {
  position: relative;
}
._song_row_music:hover .__play_now {
  display: block;
}
._song_row_music .__play_now {
  display: none;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  margin: auto;
  height: 20px;
}

._song_animation_bar {
  height: 40px;
  position: relative;
  width: 300px;
}
._song_animation_bar ._bar {
  position: absolute;
  width: inherit;
  left: 0;
}
@media (max-width: 576px) {
  ._song_animation_bar {
    display: none !important;
  }
}

._disable_siki_add {
  pointer-events: none !important;
  cursor: not-allowed !important;
  opacity: 0.2 !important;
}

.__nft_music_card {
  position: relative;
  width: 100%;
  max-height: 290px;
  margin-left: 0 !important;
  margin-bottom: 10px;
}
@media (max-width: 576px) {
  .__nft_music_card {
    width: 100%;
    max-width: none;
  }
}
@media (min-width: 768px) {
  .__nft_music_card {
    width: 180px;
    max-width: 100%;
  }
}
@media (min-width: 1024px) {
  .__nft_music_card {
    width: 210px;
    max-width: 100%;
  }
}
.__nft_music_card img {
  width: 100%;
  height: auto;
}

.transaction_button {
  min-width: 180px !important;
}

.__sell_botton {
  min-width: 180px !important;
}
@media (max-width: 576px) {
  .__sell_botton {
    min-width: fit-content !important;
  }
}

.w20 {
  width: 20px;
}

.w24 {
  width: 24px;
}

.h20 {
  height: 20px;
}

.h24 {
  height: 24px;
}

.MuiDialog-root {
  z-index: 10000 !important;
}

.Toastify__toast--info .Toastify__progress-bar {
  background-color: #FFEE20 !important;
}
.Toastify__toast--info .Toastify__toast-icon svg {
  fill: #FFEE20 !important;
}

._notAllowed {
  pointer-events: all !important;
  cursor: not-allowed !important;
}

.pl-16 {
  padding-left: 16px;
}

._cancel_button {
  background: rgba(227, 41, 62, 0.0980392157) !important;
  border-color: rgba(227, 41, 62, 0.1529411765) !important;
  color: #F06C7B !important;
  width: 90px;
}
._cancel_button svg {
  color: #F06C7B !important;
  background-color: none !important;
}
._cancel_button:hover {
  background: #E3293E !important;
  border-color: #E3293E !important;
  color: #ffffff !important;
}
._cancel_button:hover svg {
  color: #ffffff !important;
  background-color: none !important;
}

._hight30 {
  height: 30px !important;
}

._artistProfileBox {
  padding: 60px 100px 100px 100px;
  padding-bottom: 180px;
}
@media screen and (max-width: 1200px) {
  ._artistProfileBox {
    padding: 24px;
    padding-bottom: 130px;
    padding-top: 60px;
  }
}
@media screen and (max-width: 992px) {
  ._artistProfileBox {
    padding: 24px;
    padding-bottom: 130px;
    padding-top: 60px;
  }
}
@media screen and (max-width: 768px) {
  ._artistProfileBox {
    padding: 24px;
    padding-bottom: 220px;
    padding-top: 60px;
  }
}
@media (max-width: 576px) {
  ._artistProfileBox {
    padding: 24px;
    padding-bottom: 180px;
    padding-top: 60px;
  }
}
._artistProfileBox .__artistProfileMoreInfo ._artistMoreInfoInnerBox {
  width: 50%;
}
@media screen and (max-width: 1200px) {
  ._artistProfileBox .__artistProfileMoreInfo {
    flex-direction: row;
  }
  ._artistProfileBox .__artistProfileMoreInfo ._artistMoreInfoInnerBox {
    min-width: 300px;
  }
}
@media screen and (max-width: 992px) {
  ._artistProfileBox .__artistProfileMoreInfo {
    flex-direction: column;
  }
  ._artistProfileBox .__artistProfileMoreInfo ._artistMoreInfoInnerBox {
    width: initial;
  }
}
@media screen and (max-width: 768px) {
  ._artistProfileBox .__artistProfileMoreInfo {
    flex-direction: column;
  }
  ._artistProfileBox .__artistProfileMoreInfo ._artistMoreInfoInnerBox {
    width: initial;
  }
}
@media (max-width: 576px) {
  ._artistProfileBox .__artistProfileMoreInfo {
    flex-direction: column;
  }
  ._artistProfileBox .__artistProfileMoreInfo ._artistMoreInfoInnerBox {
    width: initial;
  }
}

.__player_on_pading {
  padding: 0 18px 130px 18px;
}
@media screen and (max-width: 768px) {
  .__player_on_pading {
    padding-bottom: 180px;
  }
  .p55 {
    padding-bottom: 55px !important;
  }
}

.hover\\:border-transparent:hover{
  border-color: transparent;
}

.hover\\:bg-purple-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(147 51 234 / var(--tw-bg-opacity, 1));
}

.hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-purple-600:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(147 51 234 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-offset-2:focus{
  --tw-ring-offset-width: 2px;
}

.dark\\:bg-yellow-500:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1));
}

.dark\\:text-white:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

@media (min-width: 540px){
  .sm\\:mx-0{
    margin-left: 0px;
    margin-right: 0px;
  }
  .sm\\:flex{
    display: flex;
  }
  .sm\\:shrink-0{
    flex-shrink: 0;
  }
  .sm\\:items-center{
    align-items: center;
  }
  .sm\\:space-x-6 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(1.5rem * var(--tw-space-x-reverse));
    margin-left: calc(1.5rem * calc(1 - var(--tw-space-x-reverse)));
  }
  .sm\\:space-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }
  .sm\\:p-\\[60px\\]{
    padding: 60px;
  }
  .sm\\:py-4{
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .sm\\:text-left{
    text-align: left;
  }
  .sm\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.scss","webpack://./src/styles/_mixins.scss","webpack://./src/styles/_colors.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,oDAAA;AAEA,0GAAA;AAIA;EACE;IAAA,wBAAA;IAAA,wBAAA;IAAA,mBAAA;IAAA,mBAAA;IAAA,cAAA;IAAA,cAAA;IAAA,cAAA;IAAA,eAAA;IAAA,eAAA;IAAA,aAAA;IAAA,aAAA;IAAA,kBAAA;IAAA,sCAAA;IAAA,8BAAA;IAAA,6BAAA;IAAA,4BAAA;IAAA,eAAA;IAAA,oBAAA;IAAA,sBAAA;IAAA,uBAAA;IAAA,wBAAA;IAAA,kBAAA;IAAA,2BAAA;IAAA,4BAAA;IAAA,sCAAA;IAAA,kCAAA;IAAA,2BAAA;IAAA,sBAAA;IAAA,8BAAA;IAAA,YAAA;IAAA,kBAAA;IAAA,gBAAA;IAAA,iBAAA;IAAA,kBAAA;IAAA,cAAA;IAAA,gBAAA;IAAA,aAAA;IAAA,mBAAA;IAAA,qBAAA;IAAA,2BAAA;IAAA,yBAAA;IAAA,0BAAA;IAAA,2BAAA;IAAA,uBAAA;IAAA,wBAAA;IAAA,yBAAA;IAAA,sBAAA;IAAA,oBAAA;IAAA,sBAAA;IAAA,qBAAA;IAAA;EAAA;EAAA;IAAA,wBAAA;IAAA,wBAAA;IAAA,mBAAA;IAAA,mBAAA;IAAA,cAAA;IAAA,cAAA;IAAA,cAAA;IAAA,eAAA;IAAA,eAAA;IAAA,aAAA;IAAA,aAAA;IAAA,kBAAA;IAAA,sCAAA;IAAA,8BAAA;IAAA,6BAAA;IAAA,4BAAA;IAAA,eAAA;IAAA,oBAAA;IAAA,sBAAA;IAAA,uBAAA;IAAA,wBAAA;IAAA,kBAAA;IAAA,2BAAA;IAAA,4BAAA;IAAA,sCAAA;IAAA,kCAAA;IAAA,2BAAA;IAAA,sBAAA;IAAA,8BAAA;IAAA,YAAA;IAAA,kBAAA;IAAA,gBAAA;IAAA,iBAAA;IAAA,kBAAA;IAAA,cAAA;IAAA,gBAAA;IAAA,aAAA;IAAA,mBAAA;IAAA,qBAAA;IAAA,2BAAA;IAAA,yBAAA;IAAA,0BAAA;IAAA,2BAAA;IAAA,uBAAA;IAAA,wBAAA;IAAA,yBAAA;IAAA,sBAAA;IAAA,oBAAA;IAAA,sBAAA;IAAA,qBAAA;IAAA;EAAA;EAAA,kEAAA,CAAA;;;CAAA;;AAAA;;;EAAA,sBAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,mBAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;EAAA,gBAAA;AAAA;;AAAA;;;;;;;;CAAA;;AAAA;;EAAA,gBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA,EAAA,MAAA;EAAA,WAAA,EAAA,MAAA;EAAA,+HAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,wCAAA,EAAA,MAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,yCAAA;UAAA,iCAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;EAAA,kBAAA;EAAA,oBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,mBAAA;AAAA;;AAAA;;;;;CAAA;;AAAA;;;;EAAA,+GAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,cAAA;EAAA,cAAA;EAAA,kBAAA;EAAA,wBAAA;AAAA;;AAAA;EAAA,eAAA;AAAA;;AAAA;EAAA,WAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;EAAA,yBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;EAAA,oBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gCAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,uBAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,SAAA,EAAA,MAAA;EAAA,UAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,oBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;;;EAAA,0BAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,aAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,YAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,0BAAA,EAAA,MAAA;EAAA,aAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,kBAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;;;;;;;;EAAA,SAAA;AAAA;;AAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;EAAA,UAAA;AAAA;;AAAA;;;EAAA,gBAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;EAAA,UAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,eAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;;;;EAAA,cAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;EAAA,YAAA;AAAA;;AAAA,wEAAA;AAAA;EAAA,aAAA;AAAA;AADF;AAIA;EACE;IAAA,WAAA;IAAA,kBAAA;IAAA,iBAAA;IAAA,mBAAA;IAAA;EAAA;EAAA;IAAA;MAAA;IAAA;EAAA;EAAA;IAAA;MAAA;IAAA;EAAA;EAAA;IAAA;MAAA;IAAA;EAAA;EAAA;IAAA;MAAA;IAAA;EAAA;EAAA;IAAA;MAAA;IAAA;EAAA;EACA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA,kBAAA;IAAA;EAAA;EAAA;IAAA,iBAAA;IAAA;EAAA;EAAA;IAAA,kBAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA,uBAAA;IAAA,gEAAA;IAAA;EAAA;EAAA;IAAA,uBAAA;IAAA,8DAAA;IAAA;EAAA;EAAA;IAAA,uBAAA;IAAA,4DAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA,gBAAA;IAAA,uBAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA,sBAAA;IAAA;EAAA;EAAA;IAAA,sBAAA;IAAA;EAAA;EAAA;IAAA,sBAAA;IAAA;EAAA;EAAA;IAAA,kBAAA;IAAA;EAAA;EAAA;IAAA,kBAAA;IAAA;EAAA;EAAA;IAAA,kBAAA;IAAA;EAAA;EAAA;IAAA,kBAAA;IAAA;EAAA;EAAA;IAAA,kBAAA;IAAA;EAAA;EAAA;IAAA,kBAAA;IAAA;EAAA;EAAA;IAAA,kBAAA;IAAA;EAAA;EAAA;IAAA,kBAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA,kBAAA;IAAA;EAAA;EAAA;IAAA,kBAAA;IAAA;EAAA;EAAA;IAAA,oBAAA;IAAA;EAAA;EAAA;IAAA,iBAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA,iBAAA;IAAA;EAAA;EAAA;IAAA,mBAAA;IAAA;EAAA;EAAA;IAAA,mBAAA;IAAA;EAAA;EAAA;IAAA,kBAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA,oBAAA;IAAA;EAAA;EAAA;IAAA,oBAAA;IAAA;EAAA;EAAA;IAAA,oBAAA;IAAA;EAAA;EAAA;IAAA,oBAAA;IAAA;EAAA;EAAA;IAAA,oBAAA;IAAA;EAAA;EAAA;IAAA,oBAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA,0EAAA;IAAA,8FAAA;IAAA;EAAA;EAAA;IAAA,+EAAA;IAAA,mGAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA,oBAAA;IAAA;EAAA;EAAA;IAAA,+BAAA;IAAA;EAAA;EAAA;IAAA,yBAAA;IAAA;EAAA;EAAA;IAAA,uBAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA,gKAAA;IAAA,wJAAA;IAAA,iLAAA;IAAA,wDAAA;IAAA;EAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAFF;AAMA;EACE,2CAAA;EACA,2BAAA,EAAA,eAAA;EACA,0BAAA,EAAA,qBAAA;EACA,2BAAA,EAAA,iCAAA;EACA,cAAA,EAAA,kBAAA;AAJF;;ACdA;EACE;IACE,oBAAA;EDiBF;ECfA;IACE,wBAAA;EDiBF;AACF;ACdA,kBAAA;AAYA;EACE;IACE,WAAA;IACA,UAAA;EDeF;ECbA;IACE,MAAA;IACA,UAAA;EDeF;AACF;AAnBA;EACE,kBAAA;AAqBF;;AAlBA;EACE,cAAA;EACA,oBAAA;AAqBF;;AAlBA;EACE,6BAAA;EACA,0BAAA;EACA,4BAAA;EACA,8BAAA;EACA,cAAA;AAqBF;;AAlBA;EACE,6BAAA;EACA,0BAAA;EACA,4BAAA;EACA,6BAAA;EACA,cAAA;AAqBF;;AAlBA;EACE;IACE,4CAAA;EAqBF;AACF;AAlBA;EACE,yBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,YAAA;AAoBF;;AAjBA;EACE,0BAAA;AAoBF;;AAjBA;EACE,yBAAA;AAoBF;;AAjBA;EACE,cAAA;AAoBF;;AAjBA;EACE,WAAA;AAoBF;AAlBE;EACE,0BAAA;AAoBJ;;AAhBA;EACE;IACE,uBAAA;EAmBF;EAhBA;IACE,yBAAA;EAkBF;AACF;AAfA;EACE,cErGa;EFsGb,SAAA;AAiBF;;AAdA;EACE,UAAA;EACA,WAAA;EACA,yBE3Ga;EF4Gb,aAAA;EACA,kBAAA;AAiBF;;AAdA;EACE,cEjHa;AFkIf;;AAdA;EACE,cAAA;AAiBF;;AAdA;EACE,cAAA;AAiBF;;AAdA;EACE,0BAAA;AAiBF;;AAdA;EACE,0BAAA;EACA,2CAAA;EACA,yBAAA;AAiBF;;AAdA;EACE,2BAAA;AAiBF;;AAdA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AAiBF;AC1HE;EDsGF;IAMI,sBAAA;EAkBF;AACF;;AAfA;;;EAGE,8BAAA;EACA,qCAAA;EACA,uBAAA;EAEA,0BAAA;EACA,2BAAA;AAiBF;AAfE;;;EACE,wBAAA;AAmBJ;;AAfA;EACE,YAAA;EACA,aAAA;AAkBF;ACnJE;ED+HF;IAKI,YAAA;IACA,aAAA;EAmBF;AACF;;AAhBA;EACE,YAAA;AAmBF;;AAhBA;EACE,mBAAA;AAmBF;;AAhBA;EACE,YAAA;AAmBF;;AAhBA;EACE,WAAA;AAmBF;;AAhBA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;AAmBF;AAjBE;EACE,iBAAA;AAmBJ;AAhBE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,iHAAA;AAkBJ;AClME;EDyJF;IA0BI,YAAA;EAmBF;AACF;AC/JE;EDiHF;IA8BI,WAAA;EAoBF;AACF;;AAjBA;EACE,kBAAA;AAoBF;;AAjBA;EACE,iBAAA;AAoBF;;AAjBA;EACE,mBAAA;AAoBF;;AAjBA;EACE,gBAAA;AAoBF;;AAjBA;EACE,aAAA;AAoBF;;AAjBA;EACE,aAAA;AAoBF;;AAjBA;EACE,0BAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;AAoBF;;AAjBA;EACE,0BAAA;AAoBF;;AAjBA;EACE,0BAAA;AAoBF;;AAjBA;EACE,sBAAA;AAoBF;;AAjBA;EACE,cAAA;EACA,YAAA;EACA,aAAA;EACA,gCAAA;AAoBF;AAjBE;EAPF;IAQI,0CAAA;EAoBF;AACF;AAjBE;EAZF;IAaI,qCAAA;EAoBF;AACF;AAlBE;EAhBF;IAiBI,gCAAA;EAqBF;AACF;AAnBE;EApBF;IAqBI,gCAAA;EAsBF;AACF;AApBE;EAxBF;IAyBI,2BAAA;EAuBF;AACF;AArBE;EA5BF;IA6BI,2BAAA;EAwBF;AACF;;AArBA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,cAAA;EACA,YAAA;AAwBF;;AArBA;EACE,8BAAA;AAwBF;;AArBA;EACE,8BAAA;AAwBF;;AArBA;EACE,8BAAA;AAwBF;;AArBA;EACE,2BAAA;AAwBF;;AArBA;EACE,2BAAA;AAwBF;;AArBA;EACE,2BAAA;AAwBF;;AArBA;EACE,qBAAA;AAwBF;;AArBA;EACE,mDAAA;AAwBF;;AArBA;EACE,0CAAA;AAwBF;;AArBA;EACE,yBAAA;AAwBF;;AArBA;EACE,wCAAA;AAwBF;;AArBA;EACE,gCAAA;AAwBF;;AArBA;EACE,wCAAA;AAwBF;;AArBA;EACE,wCAAA;AAwBF;;AArBA;EACE,cAAA;AAwBF;;AArBA;EACE,0BAAA;AAwBF;;AArBA;EACE,0BAAA;AAwBF;;AArBA;EACE,4BAAA;AAwBF;;AArBA;EACE,yBAAA;AAwBF;;AArBA;EACE,cAAA;AAwBF;;AArBA;EACE,4BAAA;AAwBF;;AArBA;EACE,6BAAA;AAwBF;;AArBA;EACE,cAAA;AAwBF;;AArBA;EACE,cAAA;AAwBF;;AArBA;EACE,yBAAA;AAwBF;;AArBA;EACE,wCAAA;AAwBF;;AArBA;EACE,cAAA;AAwBF;;AArBA;EACE,yBAAA;AAwBF;;AArBA;EACE,yBAAA;AAwBF;;AArBA;EACE,0BAAA;AAwBF;;AArBA;EACE,0BAAA;AAwBF;;AArBA;EACE,4BAAA;AAwBF;;AArBA;EACE,0BAAA;AAwBF;;AArBA;EACE,0BAAA;AAwBF;;AArBA;EACE,0BAAA;AAwBF;ACxbE;ED+ZF;IAII,0BAAA;EAyBF;AACF;;AAtBA;EACE,0BAAA;AAyBF;ACjcE;EDuaF;IAII,0BAAA;EA0BF;AACF;;AAvBA;EACE,0BAAA;AA0BF;;AAvBA;EACE,0BAAA;AA0BF;AC9cE;EDmbF;IAII,0BAAA;EA2BF;AACF;;AAxBA;EACE,0BAAA;AA2BF;ACvdE;ED2bF;IAII,0BAAA;EA4BF;AACF;;AAzBA;EACE,0BAAA;AA4BF;ACheE;EDmcF;IAII,0BAAA;EA6BF;AACF;;AA1BA;EACE,0BAAA;AA6BF;ACzeE;ED2cF;IAII,0BAAA;EA8BF;AACF;;AA3BA;EACE,aAAA;EACA,SAAA;AA8BF;ACnfE;EDmdF;IAKI,2BAAA;EA+BF;AACF;AC3eE;EDscF;IASI,gCAAA;EAgCF;AACF;ACzeE;ED+bF;IAaI,0CAAA;EAiCF;AACF;;AA7BA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAgCF;ACxgBE;EDqeF;IAMI,sBAAA;IACA,uBAAA;EAiCF;AACF;;AA9BA;EACE,sBAAA;EACA,uBAAA;EACA,kBAAA;AAiCF;;AA9BA;EACE,mBAAA;AAiCF;;AA9BA;EACE,8BAAA;AAiCF;;AA9BA;EACE,WAAA;AAiCF;AChiBE;ED8fF;IAII,UAAA;EAkCF;AACF;;AA/BA;EACE,oCAAA;AAkCF;;AA/BA;EACE,6BAAA;AAkCF;;AA/BA;EACE,8BAAA;AAkCF;;AA/BA;EACE,8BAAA;AAkCF;;AA/BA;EACE,YAAA;AAkCF;;AA/BA;EACE,kBAAA;EACA,YAAA;EACA,gBAAA;AAkCF;;AA/BA;EACE,kBAAA;EACA,YAAA;EACA,gBAAA;AAkCF;;AA/BA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AAkCF;;AA/BA;EACE,0BAAA;EACA,6BAAA;AAkCF;AAhCE;EACE,8BAAA;EACA,uBAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,wCAAA;AAkCJ;AAhCI;EACE,gCAAA;AAkCN;AA/BI;EACE,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AAiCN;AA7BE;EACE,cAAA;AA+BJ;AA5BE;EACE,8BAAA;EACA,oCAAA;AA8BJ;AA5BI;EACE,gCAAA;AA8BN;AA1BE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AA4BJ;;AAxBA;EACE,WAAA;EACA,YAAA;AA2BF;;AAxBA;EACE,6BAAA;EACA,oBAAA;EACA,oBAAA;EACA,mBAAA;EACA,oBAAA;EACA,uBAAA;EACA,yBAAA;EACA,0BAAA;EACA,4BAAA;AA2BF;;AAxBA;EACE,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA2BF;;AAxBA;;EAEE,4BAAA;AA2BF;;AAxBA;EACE,2BAAA;AA2BF;;AAxBA;EACE,YAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;AA2BF;AC5pBE;ED6nBF;IAOI,WAAA;IACA,YAAA;EA4BF;AACF;;AAzBA;EACE,0BAAA;AA4BF;ACtqBE;EDyoBF;IAII,0BAAA;EA6BF;AACF;AA3BE;EACE,YAAA;EAMA,eAAA;EACA,kBAAA;AAwBJ;AChrBE;EDgpBA;IAII,WAAA;EAgCJ;AACF;AA3BI;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,SAAA;EACA,YAAA;AA6BN;AAzBM;EACE,aAAA;AA2BR;ACnsBE;EDuqBI;IAII,WAAA;IACA,YAAA;EA4BR;AACF;;AAtBA;EACE,8BAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAyBF;;AAtBA;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,SAAA;AAyBF;AAvBE;EACE,YAAA;EACA,eAAA;AAyBJ;AC5tBE;EDisBA;IAKI,WAAA;EA0BJ;AACF;AAxBI;EACE,iBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AA0BN;ACvuBE;EDysBE;IAOI,WAAA;IACA,YAAA;EA2BN;AACF;AApBA;EACE,kBAAA;AAsBF;AApBE;EACE,aAAA;AAsBJ;AAlBI;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;AAoBN;;AAfA;EACE,cAAA;AAkBF;AAhBE;EACE,wCAAA;AAkBJ;;AAdA;EACE,cAAA;AAiBF;;AAdA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAiBF;;AAdA;EACE,kBAAA;EACA,YAAA;EACA,QAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AAiBF;AChyBE;EDwwBF;IAUI,YAAA;EAkBF;AACF;;AAfA;EACE,mBAAA;AAkBF;;AAfA;EACE,uDAAA;EACA,WAAA;EACA,YAAA;AAkBF;AC/yBE;ED0xBF;IAMI,sBAAA;IACA,uBAAA;EAmBF;AACF;;AAhBA;EACE,mDAAA;AAmBF;AAjBE;EACE,yBAAA;AAmBJ;;AAfA;EACE,gBAAA;AAkBF;AAdE;EALF;IAMI,2BAAA;IACA,gBAAA;EAiBF;AACF;AAfE;EAVF;IAWI,2BAAA;IACA,gBAAA;EAkBF;AACF;AAhBE;EAfF;IAgBI,6BAAA;EAmBF;AACF;AAfE;EACE,mBAAA;AAiBJ;;AAbA;EACE,yGAAA;EACA,6BAAA;EACA,qBAAA;EACA,uBAAA;EACA,yBAAA;EACA,cAAA;AAgBF;AAdE;EARF;IASI,qBAAA;EAiBF;AACF;;AAdA;EACE,2DAAA;EACA,cAAA;EACA,6BAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;AAiBF;AAfE;EARF;IASI,qBAAA;EAkBF;AACF;;AAfA;EACE,mBAAA;EACA,cAAA;EACA,6BAAA;EACA,qBAAA;EACA,uBAAA;EACA,yBAAA;AAkBF;AAhBE;EARF;IASI,qBAAA;EAmBF;AACF;;AAhBA;EACE,eAAA;EACA,6BAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,oBAAA;AAmBF;AAjBE;EACE,oCAAA;EACA,yBAAA;AAmBJ;;AAfA;EACE,UAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AAkBF;ACp5BE;ED83BF;IAOI,UAAA;IACA,aAAA;EAmBF;AACF;;AAhBA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;AAmBF;;AAhBA;EACE,+BAAA;EACA,sBAAA;AAmBF;;AAhBA;EACE,yBAAA;EACA,8BAAA;EACA,2CAAA;AAmBF;;AAhBA;EACE,cAAA;AAmBF;;AAhBA;EACE,sBAAA;AAmBF;;AAhBA;EACE,uBAAA;AAmBF;;AAhBA;EACE,mBAAA;AAmBF;;AAhBA;EACE,0BAAA;AAmBF;;AAhBA;EACE,yBAAA;AAmBF;;AAhBA;EACE,4BAAA;AAmBF;;AAhBA;EACE,kBAAA;AAmBF;;AAhBA;EACE,UAAA;EACA,YAAA;AAmBF;ACj9BE;ED47BF;IAKI,WAAA;IACA,oBAAA;EAoBF;AACF;AAlBE;EACE,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;AAoBJ;;AAhBA;EACE,yBAAA;AAmBF;;AAhBA;EACE,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AAmBF;;AAfE;EACE,YAAA;EACA,aAAA;EACA,kBAAA;AAkBJ;ACj/BE;ED49BA;IAMI,WAAA;IACA,YAAA;EAmBJ;AACF;AAhBE;EACE,aAAA;AAkBJ;AAdI;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;AAgBN;;AAVE;EACE,uBAAA;EACA,0DAAA;AAaJ;AAVE;EACE,uBAAA;EACA,qBAAA;EACA,0DAAA;EACA,8BAAA;AAYJ;AATE;EACE,oCAAA;EACA,8BAAA;AAWJ;AATI;EACE,gCAAA;EACA,2BAAA;EACA,oCAAA;AAWN;AARI;EACE,gCAAA;EACA,2BAAA;EACA,oCAAA;AAUN;;AALA;EACE,uBAAA;EACA,sBAAA;EACA,8BAAA;EACA,8BAAA;AAQF;;AALA;EACE,UAAA;AAQF;ACxiCE;ED+hCF;IAII,WAAA;EASF;AACF;;AANA;EACE,8BAAA;EACA,iBAAA;EACA,eAAA;EACA,wBAAA;AASF;;AANA;EACE,yBAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;AASF;;AALE;EACE,0BAAA;AAQJ;;AAJA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,UAAA;AAOF;;AAJA;EACE,2BAAA;EACA,uBAAA;AAOF;AALE;EACE,oCAAA;EACA,gCAAA;EACA,yBAAA;AAOJ;;AAHA;EACE,aAAA;EACA,WAAA;EACA,8BAAA;AAMF;ACvlCE;ED8kCF;IAMI,iCAAA;EAOF;AACF;;AAJA;EACE,uBAAA;AAOF;AChmCE;EDwlCF;IAII,yBAAA;EAQF;AACF;AC7jCE;EDgjCF;IAQI,yBAAA;EASF;AACF;;AANA;;EAEE,YAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AASF;AAPE;;EACE,oBAAA;EACA,uBAAA;AAUJ;AAPE;;EACE,kBAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,mBAAA;EACA,iBAAA;EACA,4BAAA;EACA,6BAAA;AAUJ;AARI;;EACE,iBAAA;EACA,gCAAA;AAWN;AATM;;EACE,yBAAA;AAYR;;AANA;EACE,uBAAA;AASF;AAPE;EACE,SAAA;AASJ;;AALA;EACE,2CAAA;AAQF;AANE;EACE,qCAAA;AAQJ;;AAJA;EACE,aAAA;AAOF;ACnqCE;ED2pCF;IAII,iCAAA;EAQF;EALA;IAEI,sBAAA;EAQJ;EAHF;IAEI,4BAAA;EAOF;EAHF;IAEI,wBAAA;EAOF;AAhBF;;AAaA;EACE,kBAAA;AAOF;AC7rCE;EDqrCF;IAII,yBAAA;EAQF;AACF;;AAJE;EACE,aAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;AAOJ;AAHI;EACE,cAAA;AAKN;;AAAA;EACE,yEAAA;EACA,6BAAA;EACA,oCAAA;AAGF;;AAAA;EACE,WAAA;EACA,YAAA;AAGF;AC3tCE;EDstCF;IAKI,sBAAA;IACA,uBAAA;EAIF;AACF;AAFE;EACE,0BAAA;EACA,uDAAA;EACA,6BAAA;AAIJ;;AAAA;EACE,MAAA;EACA,OAAA;EACA,cAAA;EACA,UAAA;EACA,sBAAA;EACA,8BAAA;EACA,mCAAA;EACA,2BAAA;EACA,yDAAA;AAGF;;AAAA;EACE,iBAAA;EACA,gBAAA;EACA,gCAAA;EACA,eAAA;AAGF;AADE;EACE,aAAA;EACA,yBAAA;EACA,UAAA;EACA,iBAAA;EACA,wBAAA;AAGJ;AAAE;EACE,8BAAA;AAEJ;AAAI;EACE,cAAA;AAEN;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE,eAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,4BAAA;AADF;AAGE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;AADJ;;AAKA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AAFF;;AAKA;EACE,6BAAA;EACA,uBAAA;EACA,2BAAA;AAFF;;AAMA;EACE,UAAA;EACA,kCAAA;AAHF;;AAMA;EACE,wBAAA;EACA,8BAAA;AAHF;ACvzCE;EDwzCF;IAKI,kBAAA;EAFF;AACF;AAIE;EACE,UAAA;AAFJ;AC/zCE;EDg0CA;IAII,WAAA;EADJ;AACF;AAIE;EACE,WAAA;EAEA,YAAA;EACA,QAAA;AAHJ;ACz0CE;EDw0CA;IAOI,WAAA;EAFJ;AACF;AAKE;EAGE,yBAAA;AALJ;;AAYA;EACE,uBAAA;AATF;;AAYA;EACE,sBAAA;AATF;;AAYA;EACE,gCAAA;AATF;;AAYA;EACE,mBAAA;EACA,YAAA;EACA,wBAAA;EACA,iCAAA;AATF;;AAYA;EACE,mBAAA;EACA,YAAA;EACA,4BAAA;EACA,iCAAA;AATF;;AAaA;EACE,6BAAA;AAVF;;AAaA;EACE,YAAA;EACA,aAAA;AAVF;;AAaA;EACE,0BAAA;AAVF;;AAaA;EACE,kCAAA;EACA,8BAAA;EACA,8BAAA;AAVF;;AAcE;EACE,WAAA;AAXJ;;AAgBE;EACE,oCAAA;EACA,gCAAA;EACA,yBAAA;AAbJ;AAeI;EACE,yBAAA;AAbN;;AAkBA;EACE,cAAA;AAfF;;AAkBA;EACE,oCAAA;EACA,sDAAA;AAfF;;AAkBA;EACE,gBAAA;AAfF;;AAkBA;EACE,yBAAA;EACA,kBAAA;AAfF;;AAkBA;EACE,kBAAA;AAfF;;AAkBA;EACE,0CAAA;EACA,mDAAA;AAfF;;AAkBA;EACE,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;AAfF;;AAkBA;EACE;IACE,iBAAA;EAfF;EAmBA;IACE,eAAA;EAjBF;AACF;AAqBA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,MAAA;AAnBF;AAsBE;EACE,0CAAA;EACA,eAAA;AApBJ;AAsBI;EACE,cAAA;AApBN;AAwBE;EACE,aAAA;EACA,WAAA;EAEA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,oBAAA;AAvBJ;;AA2BA;EACE,8BAAA;AAxBF;;AA2BA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;AAxBF;AC59CE;ED6+CF;IAUI,WAAA;IACA,WAAA;IACA,2BAAA;IACA,mBAAA;EAvBF;AACF;;AA0BA;EACE,2BAAA;EACA,4BAAA;EACA,uBAAA;EACA,wBAAA;EACA,kBAAA;AAvBF;AC5+CE;ED8/CF;IAQI,gBAAA;EAtBF;AACF;AAwBE;EAEE,qBAAA;AAvBJ;AA2BE;EACE,aAAA;EACA,gCAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,cAAA;AAzBJ;AA6BI;EACE,cAAA;AA3BN;;AAiCA;EACE,sBAAA;EACA,uBAAA;EACA,kBAAA;AA9BF;AAgCE;EACE,aAAA;EACA,gCAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;AA9BJ;AAoCI;EACE,aAAA;AAlCN;;AAwCA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;AArCF;;ACriDE;EDilDF;IAEI,aAAA;EAzCF;EA6CF;IAEI,6BAAA;IACA,QAAA;IACA,UAAA;EAzCF;EA6CF;IAEI,0BAAA;IACA,sBAAA;IACA,mBAAA;IACA,UAAA;IACA,YAAA;EAzCF;AAjBF;;AA8DA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;AAzCF;;AA4CA;EACE,6BAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;AAzCF;;AA4CA;EACE,6BAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;AAzCF;;AA4CA;EACE,sBAAA;EACA,uBAAA;EACA,oBAAA;AAzCF;;AA4CA;EAEE,cAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,0BAAA;AA1CF;;AA6CA;EACE,6BAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;AA1CF;AA4CE;EACE,UAAA;EACA,kCAAA;AA1CJ;;AA8CA;EACE,iBAAA;EACA,qBAAA;EACA,sCAAA;AA3CF;;AA8CA;EACE,YAAA;EACA,oBAAA;AA3CF;AA6CE;EACE,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AA3CJ;;AAkDA;EACE,8BAAA;EACA,uBAAA;EACA,sBAAA;EACA,qBAAA;EACA,6BAAA;AA/CF;;AAkDA;EACE,kBAAA;EACA,YAAA;AA/CF;AAiDE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;AA/CJ;;AAmDA;EACE,gBAAA;EACA,iBAAA;AAhDF;AAkDE;EAJF;IAKI,eAAA;IACA,iBAAA;EA/CF;AACF;AAiDE;EATF;IAUI,eAAA;IACA,iBAAA;EA9CF;AACF;;AAiDA;EACE,iBAAA;AA9CF;;AAiDA;EACE,YAAA;EACA,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;AA9CF;AC/qDE;EDwtDF;IAQI,WAAA;EA7CF;AACF;AA+CE;EACE,WAAA;EACA,kBAAA;AA7CJ;;AAiDA;EACE,YAAA;EACA,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;AA9CF;AChsDE;EDyuDF;IAQI,WAAA;IACA,YAAA;EA7CF;AACF;AA+CE;EACE,WAAA;EACA,kBAAA;AA7CJ;;AAiDA;EACE,YAAA;AA9CF;;AAiDA;EACE,gBAAA;AA9CF;;AAiDA;EACE,gBAAA;AA9CF;;AAiDA;EACE,8BAAA;EACA,kBAAA;EACA,+BAAA;AA9CF;;AAkDE;EADF;IAEI,wBAAA;IACA,iCAAA;EA9CF;EAgDE;IACE,2BAAA;IACA,uBAAA;IACA,0BAAA;EA9CJ;AACF;;AAkDA;EACE,UAAA;AA/CF;AAiDE;EAHF;IAII,WAAA;EA9CF;AACF;ACjvDE;ED0xDF;IAQI,WAAA;EA7CF;AACF;;AAgDA;EACE,YAAA;EACA,WAAA;AA7CF;;AAgDA;EACE,kBAAA;AA7CF;AAgDI;EACE,cAAA;AA9CN;AAkDE;EACE,aAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;AAhDJ;;AAoDA;EACE,YAAA;EACA,kBAAA;EACA,YAAA;AAjDF;AAmDE;EACE,kBAAA;EACA,cAAA;EACA,OAAA;AAjDJ;ACvxDE;EDg0DF;IAYI,wBAAA;EAjDF;AACF;;AAoDA;EACE,+BAAA;EACA,8BAAA;EACA,uBAAA;AAjDF;;AAoDA;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;AAjDF;AC1yDE;EDs1DF;IASI,WAAA;IACA,eAAA;EAjDF;AACF;AAoDE;EAdF;IAeI,YAAA;IACA,eAAA;EAjDF;AACF;AAmDE;EAnBF;IAoBI,YAAA;IACA,eAAA;EAhDF;AACF;AAmDE;EACE,WAAA;EACA,YAAA;AAjDJ;;AAoDA;EACE,2BAAA;AAjDF;;AAoDA;EACE,2BAAA;AAjDF;ACx0DE;EDw3DF;IAII,iCAAA;EAhDF;AACF;;AAmDA;EACE,WAAA;AAhDF;;AAmDA;EACE,WAAA;AAhDF;;AAmDA;EACE,YAAA;AAhDF;;AAmDA;EACE,YAAA;AAhDF;;AAmDA;EACE,yBAAA;AAhDF;;AAoDE;EACE,oCAAA;AAjDJ;AAqDI;EACE,wBAAA;AAnDN;;AAwDA;EACE,8BAAA;EACA,8BAAA;AArDF;;AAwDA;EACE,kBAAA;AArDF;;AAwDA;EACE,sDAAA;EACA,wDAAA;EACA,yBAAA;EACA,WAAA;AArDF;AAwDE;EACE,yBAAA;EACA,iCAAA;AAtDJ;AAyDE;EACE,8BAAA;EACA,gCAAA;EACA,yBAAA;AAvDJ;AAyDI;EACE,yBAAA;EACA,iCAAA;AAvDN;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,+BAAA;EACA,qBAAA;AAzDF;AA2DE;EAJF;IAKI,aAAA;IACA,qBAAA;IACA,iBAAA;EAxDF;AACF;AA0DE;EAVF;IAWI,aAAA;IACA,qBAAA;IACA,iBAAA;EAvDF;AACF;AAyDE;EAhBF;IAiBI,aAAA;IACA,qBAAA;IACA,iBAAA;EAtDF;AACF;ACn6DE;EDq8DF;IAuBI,aAAA;IACA,qBAAA;IACA,iBAAA;EArDF;AACF;AAwDI;EACE,UAAA;AAtDN;AAyDI;EALF;IAMI,mBAAA;EAtDJ;EAwDI;IACE,gBAAA;EAtDN;AACF;AAyDI;EAbF;IAcI,sBAAA;EAtDJ;EAwDI;IACE,cAAA;EAtDN;AACF;AAyDI;EArBF;IAsBI,sBAAA;EAtDJ;EAwDI;IACE,cAAA;EAtDN;AACF;ACr8DE;EDi+DA;IA8BI,sBAAA;EAtDJ;EAwDI;IACE,cAAA;EAtDN;AACF;;AA2DA;EACE,0BAAA;AAxDF;AA0DE;EAHF;IAII,qBAAA;EAvDF;EA2DF;IAEI,+BAAA;EAvDF;AALF;;AA3/DA;EAAA;AAigEC;;AAjgED;EAAA,kBAigEC;EAjgED;AAigEC;;AAjgED;EAAA,oBAigEC;EAjgED;AAigEC;;AAjgED;EAAA,8BAigEC;EAjgED;AAigEC;;AAjgED;EAAA,2GAigEC;EAjgED,yGAigEC;EAjgED;AAigEC;;AAjgED;EAAA,oBAigEC;EAjgED;AAigEC;;AAjgED;EAAA;AAigEC;;AAjgED;EAAA,kBAigEC;EAjgED;AAigEC;;AAjgED;EAAA,oBAigEC;EAjgED;AAigEC;;AAjgED;EAAA;IAAA,gBAigEC;IAjgED;EAigEC;EAjgED;IAAA;EAigEC;EAjgED;IAAA;EAigEC;EAjgED;IAAA;EAigEC;EAjgED;IAAA,uBAigEC;IAjgED,sDAigEC;IAjgED;EAigEC;EAjgED;IAAA,uBAigEC;IAjgED,2DAigEC;IAjgED;EAigEC;EAjgED;IAAA;EAigEC;EAjgED;IAAA,iBAigEC;IAjgED;EAigEC;EAjgED;IAAA;EAigEC;EAjgED;IAAA,mBAigEC;IAjgED;EAigEC;AAAA","sourcesContent":["@layer tailwind-base, primereact, tailwind-utilities;\n\n/* IMPORTANT: In \"styled\" mode you must add the PrimeReact Theme here. Do NOT include in \"unstyled\" mode */\n@import 'primereact/resources/themes/md-dark-deeppurple/theme.css' layer(primereact);\n\n\n@layer tailwind-base {\n  @tailwind base;\n}\n\n@layer tailwind-utilities {\n  @tailwind components;\n  @tailwind utilities;\n\n}\n\n.__header_extra_bold {\n  font-family: 'Inter', sans-serif !important;\n  font-weight: 800 !important; /* Extra Bold */\n  font-size: 54px !important; /* Set desired size */\n  line-height: 1.2 !important; /* Adjust line height if needed */\n  color: #ffffff; /* Example color */\n}\n\n\n@import \"./styles/colors\";\n@import \"./styles/mixins\";\n\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n.___header_logoV2 {\n  font-family: Anton !important;\n  font-size: 45px !important;\n  line-height: 45px !important;\n  margin-right: 152px !important;\n  color: #FFEE20\n}\n\n.___header_logo {\n  font-family: Anton !important;\n  font-size: 22px !important;\n  line-height: 45px !important;\n  margin-right: 50px !important;\n  color: #FFEE20\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.__main_pading {\n  padding: 0 18px 130px 18px;\n}\n\n.__sub_padding {\n  padding: 0 18px 18px 18px;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n.link {\n  color: blue;\n\n  &:hover {\n    text-decoration: underline;\n  }\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\np {\n  color: $text-primary;\n  margin: 0;\n}\n\n.___seperator {\n  width: 6px;\n  height: 6px;\n  background-color: $primary-main;\n  margin: 0 8px;\n  border-radius: 50%;\n}\n\n.text-primary {\n  color: $primary-main;\n}\n\n.text-sceonday {\n  color: #ffffff;\n}\n\n.text-black {\n  color: #000000;\n}\n\n.capitalize {\n  text-transform: capitalize;\n}\n\n.__logo_title {\n  font-size: 24px !important;\n  font-family: \"Anton\", sans-serif !important;\n  color: #ffffff !important;\n}\n\n.MuiTab-iconWrapper {\n  margin-bottom: 0 !important;\n}\n\n.__flex_responsive {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n\n  @include sm {\n    flex-direction: column;\n  }\n}\n\n.MuiButton-root,\n.MuiButton-contained,\n.MuiButton-outlined {\n  border-radius: 25px !important;\n  text-transform: capitalize !important;\n  height: 36px !important;\n\n  font-size: 12px !important;\n  font-weight: 300 !important;\n\n  &:focus {\n    outline: none !important;\n  }\n}\n\n._img_medium {\n  width: 164px;\n  height: 164px;\n\n  @include sm {\n    width: 100px;\n    height: 100px;\n  }\n}\n\n.mx-auto {\n  margin: auto;\n}\n\n.r-16 {\n  border-radius: 16px;\n}\n\n.h100 {\n  height: 100%;\n}\n\n.w100 {\n  width: 100%;\n}\n\n.__back_cover {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  margin: auto;\n  text-align: center;\n  z-index: -1;\n  filter: blur(3px);\n  opacity: 0.7;\n  height: inherit;\n  margin-top: 0;\n\n  img {\n    object-fit: cover;\n  }\n\n  ._cover_shadow {\n    height: 60px;\n    width: 100%;\n    position: absolute;\n    bottom: 0;\n    background: transparent linear-gradient(180deg, #10100F00 0%, #1E1E1E 100%) 0% 0% no-repeat padding-box;\n  }\n  @include sm{\n    width: 140vw;\n  }\n\n  @include screnRange(600,900){\n    width: 80vw;\n  }\n}\n\n.text-center {\n  text-align: center;\n}\n\n.text-right {\n  text-align: right;\n}\n\n.pr18 {\n  padding-right: 18px;\n}\n\n.text-left {\n  text-align: left;\n}\n\n.p-10 {\n  padding: 10px;\n}\n\n.p-16 {\n  padding: 16px;\n}\n\n.__small_icon {\n  font-size: 12px !important;\n  background: #4e4e4e;\n  border-radius: 50%;\n  justify-content: center;\n  padding: 2px;\n}\n\n._cp {\n  cursor: pointer !important;\n}\n\n._cd {\n  cursor: default !important;\n}\n\n.breakWord {\n  word-break: break-word;\n}\n\n.__profile_grid {\n  width: initial;\n  margin: auto;\n  display: grid;\n  grid-template-columns: auto auto;\n\n\n  @media screen and (min-width:2400px) {\n    grid-template-columns: auto auto auto auto;\n  }\n\n\n  @media only screen and (min-width: 2000px) and (max-width: 2400px) {\n    grid-template-columns: auto auto auto;\n  }\n\n  @media screen and (max-width:1800px) {\n    grid-template-columns: auto auto;\n  }\n\n  @media only screen and (min-width: 992px) and (max-width: 1200px) {\n    grid-template-columns: auto auto;\n  }\n\n  @media only screen and (min-width: 576px) and (max-width: 991px) {\n    grid-template-columns: auto;\n  }\n\n  @media screen and (max-width:576px) {\n    grid-template-columns: auto;\n  }\n}\n\n.__moonpay {\n  display: flex;\n  flex-direction: column;\n  max-height: 80vh;\n  max-width: 400px;\n  background: #ffffff;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: 0 auto;\n  padding: 5px;\n}\n\n.mb-20 {\n  margin-bottom: 20px !important;\n}\n\n.mb-10 {\n  margin-bottom: 10px !important;\n}\n\n.mb-15 {\n  margin-bottom: 15px !important;\n}\n\n.mt-10 {\n  margin-top: 10px !important;\n}\n\n.mt-20 {\n  margin-top: 20px !important;\n}\n\n.mt-30 {\n  margin-top: 30px !important;\n}\n\n.MuiSlider-root {\n  padding: 0 !important;\n}\n\n.fade-text {\n  color: #ffffff70 !important;\n}\n\n.fade-text-60 {\n  color: #ffffffcc !important;\n}\n\n.text-dark {\n  color: #1e1e1e !important;\n}\n\n.light-text {\n  color: #ffffffcb;\n}\n\n._bb {\n  border-bottom: 1px solid #e5e5e5;\n}\n\n.fade-text80 {\n  color: #ffffff80;\n}\n\n.fade-text50 {\n  color: #ffffff50;\n}\n\n.text-white {\n  color: #ffffff;\n}\n\n.underline {\n  text-decoration: underline;\n}\n\n.text-capitalize {\n  text-transform: capitalize;\n}\n\n.fw-b {\n  font-weight: bold !important;\n}\n\n.upper {\n  text-transform: uppercase;\n}\n\n.MuiButton-endIcon {\n  margin-left: 0;\n}\n\n.ml_auto {\n  margin-left: auto !important;\n}\n\n.mr_auto {\n  margin-right: auto !important;\n}\n\n.success {\n  color: #05c95f;\n}\n\n.online {\n  color: #2CF488;\n}\n\n.error {\n  color: #e3293e !important;\n}\n\n.other {\n  color: #ffffff50;\n}\n\n.canceled {\n  color: #FFEE20;\n}\n\n.bg_primary {\n  background-color: #FFEE20\n}\n\n.fs-9 {\n  font-size: 9px !important;\n}\n\n.fs-10 {\n  font-size: 10px !important;\n}\n\n.fs-11 {\n  font-size: 11px !important;\n}\n\n.fs-11-5 {\n  font-size: 11.5px !important;\n}\n\n.fs-12 {\n  font-size: 12px !important;\n}\n\n.fs-13 {\n  font-size: 13px !important;\n}\n\n.fs-14 {\n  font-size: 14px !important;\n\n  @include sm {\n    font-size: 12px !important;\n  }\n}\n\n.fs-15 {\n  font-size: 15px !important;\n\n  @include sm {\n    font-size: 13px !important;\n  }\n}\n\n.fs-17 {\n  font-size: 17px !important;\n}\n\n.fs-18 {\n  font-size: 18px !important;\n\n  @include sm {\n    font-size: 16px !important;\n  }\n}\n\n.fs-20 {\n  font-size: 20px !important;\n\n  @include sm {\n    font-size: 18px !important;\n  }\n}\n\n.fs-24 {\n  font-size: 24px !important;\n\n  @include sm {\n    font-size: 20px !important;\n  }\n}\n\n.fs-30 {\n  font-size: 30px !important;\n\n  @include sm {\n    font-size: 26px !important;\n  }\n}\n\n.grid {\n  display: grid;\n  gap: 10px;\n\n  @include sm {\n    grid-template-columns: auto;\n  }\n\n  @include md {\n    grid-template-columns: auto auto;\n  }\n\n  @include lg {\n    grid-template-columns: auto auto auto auto;\n  }\n\n}\n\n.avatar {\n  width: 44px ;\n  height: 44px ;\n  border-radius: 50%;\n\n  @include sm {\n    width: 30px !important;\n    height: 30px !important;\n  }\n}\n\n.avatar-sm {\n  width: 28px !important;\n  height: 28px !important;\n  border-radius: 50%;\n}\n\n.PrivateSwipeArea-root {\n  width: 0 !important;\n}\n\n.MuiOutlinedInput-root {\n  border-radius: 30px !important;\n}\n\n.test-width {\n  width: 100%;\n\n  @include sm {\n    width: 65%;\n  }\n}\n\n.b-white {\n  border: 1px solid #ffffff !important;\n}\n\n.br-50 {\n  border-radius: 50% !important;\n}\n\n.br-25 {\n  border-radius: 25px !important;\n}\n\n.br16 {\n  border-radius: 16px !important;\n}\n\n.p2 {\n  padding: 2px;\n}\n\n.__home {\n  position: relative;\n  height: 78vh;\n  overflow: scroll;\n}\n\n.__home_no_player {\n  position: relative;\n  height: 85vh;\n  overflow: scroll;\n}\n\n.__player_image {\n  width: 306px;\n  height: 306px;\n  border-radius: 16px;\n  object-fit: cover;\n}\n\n.__upload_inputbox {\n  margin-top: 7px !important;\n  position: relative !important;\n\n  .__input {\n    border-radius: 25px !important;\n    height: 50px !important;\n    background-color: #262626 !important;\n    display: flex;\n    align-items: center;\n    padding-left: 12px;\n    color: #ffffff50;\n\n    fieldset {\n      border-color: #262626 !important;\n    }\n\n    .__selectedImg {\n      height: 100%;\n      border-radius: 50%;\n      width: 42px;\n      height: 42px;\n    }\n  }\n\n  .__input_filled {\n    color: #ffffff;\n  }\n\n  .__input_area {\n    border-radius: 25px !important;\n    background-color: #171515 !important;\n\n    fieldset {\n      border-color: #262626 !important;\n    }\n  }\n\n  .__input_icon {\n    position: absolute;\n    right: 24px;\n    top: 11px;\n  }\n}\n\n.badgeSize {\n  width: 100%;\n  height: 100%;\n}\n\n.avgLevel {\n  position: absolute !important;\n  top: 40px !important;\n  left: 8px !important;\n  right: 0 !important;\n  bottom: 0 !important;\n  margin: auto !important;\n  color: #ffffff !important;\n  font-size: 40px !important;\n  font-weight: bold !important;\n}\n\n.social-box {\n  background: #262626;\n  border-radius: 25px;\n  padding: 4px 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n#gender_border,\n#age_border, #género_border, #años_border, #Пол_border, #возраст_border {\n  fill: transparent !important;\n}\n\n.flex-responsive {\n  justify-content: flex-start;\n}\n\n.__assets__ {\n  width: 210px;\n  height: 210px;\n  object-fit: cover;\n  border-radius: 6px;\n\n  @include sm {\n    width: 96px;\n    height: 96px;\n  }\n}\n\n.__assets_container__ {\n  padding: 0 24px 100px 24px;\n\n  @include sm {\n    padding: 0 10px 100px 10px;\n  }\n\n  .__asset_col {\n    width: 210px;\n\n    @include sm {\n      width: 96px;\n    }\n\n    cursor: pointer;\n    position: relative;\n\n    .__asset_hover {\n      display: none;\n      align-items: center;\n      width: max-content;\n      height: 38px;\n      top: 0;\n      right: 0;\n      left: 0;\n      bottom: 0;\n      margin: auto;\n    }\n\n    &:hover {\n      .__asset_hover {\n        display: flex;\n\n        @include sm {\n          width: 96px;\n          height: 96px;\n        }\n      }\n    }\n  }\n}\n\n.__private {\n  background: #4e4e4e !important;\n  color: #989898 !important;\n  width: 12px;\n  height: 12px;\n  padding: 4px;\n}\n\n.__card_container {\n  display: flex;\n  flex-direction: row !important;\n  flex-wrap: wrap;\n  gap: 20px;\n\n  .__card_widget {\n    width: 210px;\n    cursor: pointer;\n\n    @include sm {\n      width: 96px;\n    }\n\n    .__card_widget_image {\n      object-fit: cover;\n      width: 210px;\n      height: 210px;\n      border-radius: 6px;\n\n      @include sm {\n        width: 96px;\n        height: 96px;\n      }\n    }\n\n    .__card_widget_detail {}\n  }\n}\n\n.__music_thumb {\n  position: relative;\n\n  .__play_hover {\n    display: none;\n  }\n\n  &:hover {\n    .__play_hover {\n      display: block;\n      width: 25px;\n      position: absolute;\n      top: 0px;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      margin: auto;\n    }\n  }\n}\n\n.__volume_button {\n  color: #ffffff;\n\n  &:hover {\n    color: #ffffff70;\n  }\n}\n\n.__volume_active {\n  color: #FFEE20;\n}\n\n.__volume {\n  position: absolute;\n  top: -118px;\n  left: 10px;\n  height: 75px;\n  padding: 10px 0;\n  border-radius: 12px;\n  width: 24px;\n  background: #262626;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.__player_queue {\n  position: absolute;\n  bottom: 60px;\n  right: 0;\n  width: 400px;\n  min-height: 400px;\n  background: #171515;\n  overflow: scroll;\n\n  @include sm {\n    width: 250px;\n  }\n}\n\n.nowrap {\n  white-space: nowrap;\n}\n\n.__more_hover {\n  background: #ffffff5e !important;\n  width: 30px;\n  height: 30px;\n\n  @include sm {\n    width: 20px !important;\n    height: 20px !important;\n  }\n}\n\n.__more_hover_color {\n  color: #ffffff90 !important;\n\n  &:hover {\n    color: #ffffff !important;\n  }\n}\n\n.__profile_card {\n  min-width: 400px;\n\n\n\n  @media screen and (min-width:992px) and (max-width:1200px) {\n    max-width: 340px !important;\n    min-width: 320px;\n  }\n\n  @media screen and (max-width: 992px) {\n    max-width: unset !important;\n    min-width: 320px;\n  }\n\n  @media screen and (min-width: 576px) and (max-width:991px) {\n    max-width: initial !important;\n\n  }\n\n\n  &:hover {\n    background: #1a1a1a;\n  }\n}\n\n.__level_graph {\n  background-image: linear-gradient(180deg, #05c95f40, #3bf00540);\n  border-radius: 3px !important;\n  width: 8px !important;\n  height: 12px !important;\n  padding: 1.5px !important;\n  color: #ffffff;\n\n  @media screen and (min-width:992px) and (max-width:1200px) {\n    width: 3px !important;\n  }\n}\n\n.__level_graph1 {\n  background-image: linear-gradient(180deg, #05c95f, #3bf005);\n  color: #3bf005;\n  border-radius: 3px !important;\n  width: 10px !important;\n  height: 15px !important;\n  padding: 1.5px !important;\n\n  @media screen and (min-width:992px) and (max-width:1200px) {\n    width: 3px !important;\n  }\n}\n\n.__level_graph2 {\n  background: #4e6257;\n  color: #4e6257;\n  border-radius: 3px !important;\n  width: 8px !important;\n  height: 12px !important;\n  padding: 1.5px !important;\n\n  @media screen and (min-width:992px) and (max-width:1200px) {\n    width: 3px !important;\n  }\n}\n\n.__edit_profile_button {\n  cursor: pointer;\n  position: absolute !important;\n  width: 97px !important;\n  font-size: 12px !important;\n  font-weight: 400 !important;\n  height: 36px !important;\n  right: 24px !important;\n  top: 24px !important;\n\n  &:hover {\n    background-color: #FFEE20 !important;\n    color: #1e1e1e !important;\n  }\n}\n\n.__update_prfofile_box {\n  width: 50%;\n  margin: auto;\n  padding: 50px 117px;\n  background: #090909;\n\n  @include sm {\n    width: 90%;\n    padding: 10px;\n  }\n}\n\n.__back {\n  position: absolute;\n  z-index: 1;\n  top: 10px;\n  left: 10px;\n}\n\n.__br {\n  border-right: 1px solid #929292;\n  padding: 0 7px 0px 0px;\n}\n\n.web_header {\n  margin: 0 18px !important;\n  padding-bottom: 5px !important;\n  border-bottom: 1px solid #262626 !important;\n}\n\n.faded {\n  color: #999999;\n}\n\n.w24 {\n  width: 24px !important;\n}\n\n.h24 {\n  height: 24px !important;\n}\n\n.text-justify {\n  text-align: justify;\n}\n\n.mt-5 {\n  margin-top: 5px !important;\n}\n\n.my-10 {\n  margin: 10px 0 !important;\n}\n\n.ml-40 {\n  margin-left: 40px !important;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.__add_balance_tab {\n  width: 30%;\n  margin: auto;\n\n  @include sm {\n    width: 100%;\n    padding: 0 0 100px 0;\n  }\n\n  .__balance_row {\n    height: 50px;\n    background: #090909;\n    align-items: center;\n    padding: 0 10px;\n    border-radius: 8px;\n    cursor: pointer;\n  }\n}\n\n.transform180 {\n  transform: rotate(180deg);\n}\n\n.__Search_result_box {\n  z-index: 2;\n  background: #171515;\n  position: absolute;\n  top: 50px;\n  width: 100%;\n}\n\n.__artist_thumbnail {\n  .__large_avatar {\n    width: 210px;\n    height: 210px;\n    border-radius: 50%;\n\n    @include sm {\n      width: 96px;\n      height: 96px;\n    }\n  }\n\n  .__play_hover_artist {\n    display: none;\n  }\n\n  &:hover {\n    .__play_hover_artist {\n      display: block;\n      position: absolute;\n      top: 0;\n      right: 0;\n      left: 0;\n      bottom: 0;\n      margin: auto;\n      width: 44px;\n    }\n  }\n}\n\n.MuiOutlinedInput-root {\n  #_search_icon {\n    height: 100% !important;\n    border-color: #6767674d !important;\n  }\n\n  #search-input {\n    height: 100% !important;\n    padding: 0 !important;\n    border-color: #6767674d !important;\n    border-radius: 25px !important;\n  }\n\n  &:hover {\n    background-color: #000000 !important;\n    border-radius: 25px !important;\n\n    #_search_icon {\n      border-color: #000000 !important;\n      outline: #000000 !important;\n      background-color: #000000 !important;\n    }\n\n    #search-input {\n      border-color: #000000 !important;\n      outline: #000000 !important;\n      background-color: #000000 !important;\n    }\n  }\n}\n\n.__selectedImg {\n  height: 100% !important;\n  width: 100% !important;\n  object-fit: contain !important;\n  border-radius: 25px !important;\n}\n\n.w50_responsive {\n  width: 50%;\n\n  @include sm {\n    width: 100%;\n  }\n}\n\n.__0 {\n  border-left: 1px solid #707070;\n  padding-left: 6px;\n  font-size: 18px;\n  transition: transform 1s;\n}\n\n.__180 {\n  transform: rotate(180deg);\n  border-right: 1px solid #000000;\n  padding-right: 6px;\n  font-size: 18px;\n}\n\n.__underline_hover {\n  &:hover {\n    text-decoration: underline;\n  }\n}\n\n.__buy_bid_info {\n  position: absolute;\n  top: -35px;\n  right: 30px;\n  background: #262626;\n  width: 45%;\n}\n\n.__hover_button {\n  font-weight: 400 !important;\n  height: 36px !important;\n\n  &:hover {\n    background-color: #FFEE20 !important;\n    border-color: #FFEE20 !important;\n    color: #000000 !important;\n  }\n}\n\n._responsive_flex {\n  display: flex;\n  width: 100%;\n  flex-direction: row !important;\n\n  @include sm {\n    flex-direction: column !important;\n  }\n}\n\n.__responsive_playlist_statics_card {\n  width: 272px !important;\n\n  @include sm {\n    width: inherit !important;\n  }\n\n  @include screnRange(\"1600\", \"3000\") {\n    width: inherit !important;\n  }\n}\n\n.__custom_dropdown_container,\n._playlist_topfive_dropdown_container {\n  height: 50px;\n  position: relative;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #171515;\n  border-radius: 25px;\n  cursor: pointer;\n\n  .__transform {\n    transition: all 0.5s;\n    transform: rotate(0deg);\n  }\n\n  .__custom_dropdown {\n    position: absolute;\n    top: 50px;\n    max-height: 200px;\n    overflow: scroll;\n    z-index: 1;\n    background: #171515;\n    padding: 0px 16px;\n    border-radius: 0 0 25px 25px;\n    width: -webkit-fill-available;\n\n    .__custom_dropdown_item {\n      padding: 10px 5px;\n      border-bottom: 1px solid #e5e5e5;\n\n      &:hover {\n        background-color: #10100f;\n      }\n    }\n  }\n}\n\n._playlist_topfive_dropdown_container {\n  height: 30px !important;\n\n  .__custom_dropdown {\n    top: 30px;\n  }\n}\n\n._show_dropdown {\n  border-radius: 25px 25px 0px 0px !important;\n\n  .__transform {\n    transform: rotateZ(180deg) !important;\n  }\n}\n\n.responsive-flex {\n  display: flex;\n\n  @include sm {\n    flex-direction: column !important;\n  }\n\n  ._flex_width {\n    @include sm {\n      width: auto !important;\n    }\n  }\n}\n\n.__header_left_items {\n  @include sm {\n    margin-left: auto !important;\n  }\n}\n\n._display_none {\n  @include sm {\n    display: none !important;\n  }\n}\n\n.responsive_margin_100 {\n  margin-left: 100px;\n\n  @include sm {\n    margin-left: 0 !important;\n  }\n}\n\n.__player_queue_image {\n  ._play_queue_play {\n    display: none;\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    margin: auto;\n    width: 20px;\n  }\n\n  &:hover {\n    ._play_queue_play {\n      display: block;\n    }\n  }\n}\n\n.__tip_gradiant {\n  background: linear-gradient(to right, #FFEE20, #ffb715, #ff1cbe, #00c3fd);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.__responsive_play {\n  width: 30px;\n  height: 30px;\n\n  @include sm {\n    width: 20px !important;\n    height: 20px !important;\n  }\n\n  .__more_icon {\n    font-size: 30px !important;\n    background: #ffffff5e !important;\n    border-radius: 50% !important;\n  }\n}\n\n.is-sticky {\n  top: 0;\n  left: 0;\n  width: 90% 100;\n  z-index: 1;\n  padding: 38px 18px 5px;\n  background: rgba(0,0,0,.3);\n  -webkit-backdrop-filter: blur(30px);\n  backdrop-filter: blur(45px);\n  box-shadow: inset 0px -25px 20px 10px rgba(0,0,0,0.75);\n}\n\n.__playlistNft_music {\n  padding: 5px 10px;\n  margin: 5px 10px;\n  border-bottom: 1px solid #1E1E1E;\n  cursor: pointer;\n\n  .__playlistNft_music_back {\n    display: none;\n    transform: rotate(180deg);\n    width: 8px;\n    margin-left: auto;\n    transition: display .2s;\n  }\n\n  &:hover {\n    background: #000000 !important;\n\n    .__playlistNft_music_back {\n      display: block;\n\n    }\n  }\n}\n\n.pos_r {\n  position: relative;\n}\n\n._position_relative {\n  position: relative;\n}\n\n.__chat_icon_container {\n  cursor: pointer;\n  position: absolute;\n  right: 0;\n  top: 4%;\n  width: 48px;\n  height: 48px;\n  background: #4e4949;\n  border-radius: 30px 0 0 30px;\n\n  .__chat_icon {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    margin: auto;\n  }\n}\n\n._chat_online {\n  position: absolute;\n  right: 15px;\n  top: 11px;\n}\n\n.emoji-picker-react {\n  position: absolute !important;\n  bottom: 60px !important;\n  box-shadow: none !important;\n\n}\n\n._chat_opened_music {\n  width: 80%;\n  transition: width 0.2s ease-in-out;\n}\n\n._chat_open {\n  display: flex !important;\n  flex-direction: row !important;\n\n  @include sm {\n    position: relative;\n  }\n\n  ._chat_opened_music {\n    width: 80%;\n\n    @include sm {\n      width: 100%;\n    }\n  }\n\n  .__chat_container {\n    width: 100%;\n\n    height: 100%;\n    right: 0;\n\n    @include sm {\n      width: 100%;\n    }\n  }\n\n  .__chat_container_with_song {\n\n\n    height: calc(100% - 55px);\n\n\n  }\n\n}\n\n.__chat_container_with_song_artist {\n  bottom: 70px !important;\n}\n\n.__chat_container_without_song_artist {\n  bottom: 0px !important;\n}\n\n.ls2-2 {\n  letter-spacing: 2.2px !important;\n}\n\n._chat_from {\n  background: #2C2C2C;\n  padding: 7px;\n  border-radius: 6px 6px 0;\n  word-break: break-word !important;\n}\n\n._chat_to {\n  background: #2C2C2C;\n  padding: 7px;\n  border-radius: 6px 6px 6px 0;\n  word-break: break-word !important;\n\n}\n\n._anton {\n  font-family: Anton !important;\n}\n\n._img_large {\n  width: 229px;\n  height: 229px;\n}\n\n.noScroll {\n  overflow: unset !important;\n}\n\n._line_through {\n  text-decoration-line: line-through;\n  text-decoration-color: #FFEE20;\n  text-decoration-thickness: 2px;\n}\n\n._lock_hover {\n  &:hover {\n    color: #fff;\n  }\n}\n\n.__play_all {\n  &:hover {\n    background-color: #FFEE20 !important;\n    border-color: #FFEE20 !important;\n    color: #1E1E1E !important;\n\n    .__play_all_play {\n      color: #1E1E1E !important;\n    }\n  }\n}\n\n.white-secondary {\n  color: #D5D5D5;\n}\n\n.__icon_button {\n  border: 1px solid #FFFFFF !important;\n  box-shadow: 0px 3px 6px #76390524;\n}\n\n._pre_space {\n  white-space: pre;\n}\n\n.faded-round-border {\n  border: 1px solid #999999;\n  border-radius: 50%;\n}\n\n.-mr-9 {\n  margin-right: -9px;\n}\n\n._stream_msg {\n  background: #2C2C2C50;\n  box-shadow: 0px 7px 6px #00000005;\n}\n\n.__polygon_img {\n  width: 36px;\n  border: 1px solid #fff;\n  border-radius: 50%;\n  padding: 8px;\n}\n\n@keyframes slidein {\n  from {\n    margin-left: 100%;\n\n  }\n\n  to {\n    margin-left: 0%;\n\n  }\n}\n\n.__audience_tip {\n  width: 108px;\n  height: 108px;\n  position: absolute;\n  top: 0;\n\n\n  &:hover {\n    background: #1e1e1ec2;\n    cursor: pointer;\n\n    .__audience_tip_icon {\n      display: block;\n    }\n  }\n\n  .__audience_tip_icon {\n    display: none;\n    width: 32px;\n\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    margin: auto;\n    transition: all 0.2s\n  }\n}\n\n.agora_video_player {\n  object-fit: contain !important;\n}\n\n#cohost_video_box {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  flex-direction: column;\n  overflow-y: scroll;\n  background: #000;\n  gap: .5rem;\n\n  @include sm {\n    gap: .5rem;\n    grid-row: 1;\n    justify-content: flex-start;\n    flex-direction: row;\n  }\n}\n\n._un_pin_ {\n  min-width: 160px !important;\n  min-height: 160px !important;\n  width: 160px !important;\n  height: 160px !important;\n  position: relative;\n\n  @include sm {\n    overflow: scroll;\n  }\n\n  .agora_video_player {\n\n    scale: 1.5 !important;\n\n  }\n\n  ._pin_class {\n    display: none;\n    transition: all 0.2s ease-in-out;\n    cursor: pointer;\n    width: 24px;\n    height: 24px;\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    margin: auto;\n    z-index: 10000;\n  }\n\n  &:hover {\n    ._pin_class {\n      display: block;\n\n    }\n  }\n}\n\n._pin_ {\n  width: 100% !important;\n  height: 100% !important;\n  position: relative;\n\n  ._pin_class {\n    display: none;\n    transition: all 0.2s ease-in-out;\n    cursor: pointer;\n    width: 24px;\n    height: 24px;\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    margin: auto;\n  }\n\n\n\n  &:hover {\n    ._pin_class {\n      display: none;\n\n    }\n  }\n}\n\n._speaking {\n  width: 28px;\n  height: 28px;\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  border-radius: 50%;\n  z-index: 10000;\n\n}\n\n._pin_width {\n}\n\n#_share_screen_btn {\n  @include sm {\n    display: none;\n  }\n}\n\n._playlist_streaming_camera {\n  @include sm {\n    position: absolute !important;\n    right: 0;\n    top: -41px;\n  }\n}\n\n.streaming_control_box_audience {\n  @include sm {\n    position: fixed !important;\n    right: 10px !important;\n    top: 0px !important;\n    z-index: 1;\n    height: 42px;\n  }\n}\n\n.taptostart {\n  width: 28px;\n  height: 28px;\n  position: absolute;\n  top: 8px;\n  right: 46px;\n  border: 2px solid #ffffff;\n  z-index: 10000;\n  cursor: pointer;\n}\n\n._copy_artist {\n  position: absolute !important;\n  z-index: 1;\n  top: 10px;\n  right: 10px;\n}\n\n._copy_artist_edit {\n  position: absolute !important;\n  z-index: 1;\n  top: 24px;\n  right: 126px;\n}\n\n._webview_streaming {\n  width: 100% !important;\n  height: 100% !important;\n  margin: 0 !important;\n}\n\n._new_raised_dot {\n\n  color: #E3293E;\n  position: absolute;\n  top: -5px;\n  border-radius: 50%;\n  font-size: 14px !important;\n}\n\n._upload_video {\n  position: absolute !important;\n  z-index: 1;\n  top: 27px;\n  right: 220px;\n\n  input {\n    width: 0px;\n    transition: width .2s ease-in-out;\n  }\n}\n\n._share_url {\n  top: 0 !important;\n  width: 98% !important;\n  height: calc(100vh - 100px) !important;\n}\n\n._upload_video_box {\n  height: 40px;\n  top: 24px !important;\n\n  textarea {\n    width: 444px;\n    height: 32px;\n    font-size: 14px;\n    margin-right: 70px;\n  }\n}\n\n.MuiMenu-list {\n}\n\n.MuiMenu-paper {\n  background: #1e1e1e !important;\n  bottom: 80px !important;\n  right: 14px !important;\n  top: unset !important;\n  width: fit-content !important;\n}\n\n.__chat_typing_streaming {\n  position: absolute;\n  bottom: 50px;\n\n  .__typing {\n    color: #BDBDBD;\n    font-style: italic;\n    font-size: 12px;\n  }\n}\n\n._profile_alignment {\n  padding: 0 100px;\n  padding-top: 66px;\n\n  @media (max-width: 1200px) {\n    padding: 0 30px;\n    padding-top: 66px;\n  }\n\n  @media (max-width: 992px) {\n    padding: 0 30px;\n    padding-top: 66px;\n  }\n}\n\n._object-cover {\n  object-fit: cover;\n}\n\n._nft_list_gift_card {\n  width: 210px;\n  height: 230px;\n  border: 1px solid #707070;\n  background: #000;\n  border-radius: 6px;\n\n  @include sm {\n    width: 100%;\n  }\n\n  img {\n    width: 100%;\n    border-radius: 6px;\n  }\n}\n\n._nft_list_gift_card_playlist {\n  width: 210px;\n  height: 210px;\n  border: 1px solid #707070;\n  background: #000;\n  border-radius: 6px;\n\n  @include sm {\n    width: 100%;\n    height: 96px;\n  }\n\n  img {\n    width: 100%;\n    border-radius: 6px;\n  }\n}\n\n.p5 {\n  padding: 5px;\n}\n\n.text-left {\n  text-align: left;\n}\n\n.white-space-pre {\n  white-space: pre;\n}\n\n._generateButton {\n  height: fit-content !important;\n  width: max-content;\n  line-height: inherit !important;\n}\n\n._responsive_row {\n  @media (min-width: 576px) and (max-width: 800px) {\n    display: flex !important;\n    flex-direction: column !important;\n\n    ._generateButton {\n      max-width: 150px !important;\n      height: 30px !important;\n      font-size: 14px !important;\n    }\n  }\n}\n\n.__follow_container {\n  width: 75%;\n\n  @media screen and (max-width:820px) and (min-width:576px) {\n    width: 100%;\n  }\n\n  @include sm {\n    width: 100%;\n  }\n}\n\n._small_icons {\n  height: 20px;\n  width: 20px;\n}\n\n._song_row_music {\n  position: relative;\n\n  &:hover {\n    .__play_now {\n      display: block\n    }\n  }\n\n  .__play_now {\n    display: none;\n    position: absolute;\n    top: 0;\n    right: 0;\n    left: 0;\n    bottom: 0;\n    margin: auto;\n    height: 20px;\n  }\n}\n\n._song_animation_bar {\n  height: 40px;\n  position: relative;\n  width: 300px;\n\n  ._bar {\n    position: absolute;\n    width: inherit;\n    left: 0;\n  }\n\n  @include sm {\n    display: none !important;\n  }\n}\n\n._disable_siki_add {\n  pointer-events: none !important;\n  cursor: not-allowed !important;\n  opacity: .2 !important;\n}\n\n.__nft_music_card {\n  position: relative;\n  width: 100%;         // Allow the card to take up 100% of the container's width\n  max-height: 290px;   // This can remain if the height should be capped\n  margin-left: 0 !important;\n  margin-bottom: 10px;\n\n  // Adjust card size based on screen size\n  @include sm {\n    width: 100%;\n    max-width: none;    // Remove any max-width constraints on small screens\n  }\n\n  // For medium to large screens, adjust width dynamically\n  @media (min-width: 768px) {\n    width: 180px;      // Width for medium screens\n    max-width: 100%;\n  }\n\n  @media (min-width: 1024px) {\n    width: 210px;      // Width for larger screens\n    max-width: 100%;\n  }\n\n  // Ensure the card scales properly inside the carousel\n  img {\n    width: 100%;       // Ensure any images inside the card also scale with the card\n    height: auto;      // Maintain aspect ratio for images\n  }\n}\n.transaction_button {\n  min-width: 180px !important;\n}\n\n.__sell_botton {\n  min-width: 180px !important;\n\n  @include sm {\n    min-width: fit-content !important;\n  }\n}\n\n.w20 {\n  width: 20px;\n}\n\n.w24 {\n  width: 24px;\n}\n\n.h20 {\n  height: 20px;\n}\n\n.h24 {\n  height: 24px;\n}\n\n.MuiDialog-root {\n  z-index: 10000 !important;\n}\n\n.Toastify__toast--info {\n  .Toastify__progress-bar {\n    background-color: #FFEE20 !important;\n  }\n\n  .Toastify__toast-icon {\n    svg {\n      fill: #FFEE20 !important;\n    }\n  }\n}\n\n._notAllowed {\n  pointer-events: all !important;\n  cursor: not-allowed !important;\n}\n\n.pl-16 {\n  padding-left: 16px;\n}\n\n._cancel_button {\n  background: #E3293E19 !important;\n  border-color: #E3293E27 !important;\n  color: #F06C7B !important;\n  width: 90px;\n\n\n  svg {\n    color: #F06C7B !important;\n    background-color: none !important;\n  }\n\n  &:hover {\n    background: #E3293E !important;\n    border-color: #E3293E !important;\n    color: #ffffff !important;\n\n    svg {\n      color: #ffffff !important;\n      background-color: none !important;\n    }\n  }\n}\n\n._hight30 {\n  height: 30px !important;\n}\n\n._artistProfileBox {\n  padding: 60px 100px 100px 100px;\n  padding-bottom: 180px;\n\n  @media screen and (max-width:1200px) {\n    padding: 24px;\n    padding-bottom: 130px;\n    padding-top: 60px;\n  }\n\n  @media screen and (max-width:992px) {\n    padding: 24px;\n    padding-bottom: 130px;\n    padding-top: 60px;\n  }\n\n  @media screen and (max-width:768px) {\n    padding: 24px;\n    padding-bottom: 220px;\n    padding-top: 60px;\n  }\n\n  @include sm {\n    padding: 24px;\n    padding-bottom: 180px;\n    padding-top: 60px;\n  }\n\n  .__artistProfileMoreInfo {\n    ._artistMoreInfoInnerBox {\n      width: 50%;\n    }\n\n    @media screen and (max-width:1200px) {\n      flex-direction: row;\n\n      ._artistMoreInfoInnerBox {\n        min-width: 300px;\n      }\n    }\n\n    @media screen and (max-width:992px) {\n      flex-direction: column;\n\n      ._artistMoreInfoInnerBox {\n        width: initial;\n      }\n    }\n\n    @media screen and (max-width:768px) {\n      flex-direction: column;\n\n      ._artistMoreInfoInnerBox {\n        width: initial;\n      }\n    }\n\n    @include sm {\n      flex-direction: column;\n\n      ._artistMoreInfoInnerBox {\n        width: initial;\n      }\n    }\n  }\n}\n\n.__player_on_pading {\n  padding: 0 18px 130px 18px;\n\n  @media screen and (max-width: 768px){\n    padding-bottom: 180px;\n  }\n}\n\n.p55{\n  @media screen and (max-width: 768px){\n    padding-bottom: 55px !important;\n  }\n}\n\n","@import \"./colors.scss\";\n@import \"./breakpoints\";\n\n@keyframes animationRotate {\n  from {\n    transform: rotate(0);\n  }\n  to {\n    transform: rotate(1turn);\n  }\n}\n\n/* Add Animation */\n@-webkit-keyframes animatetop {\n  from {\n    top: -300px;\n    opacity: 0;\n  }\n  to {\n    top: 0;\n    opacity: 1;\n  }\n}\n\n@keyframes animatetop {\n  from {\n    top: -300px;\n    opacity: 0;\n  }\n  to {\n    top: 0;\n    opacity: 1;\n  }\n}\n\n// Small devices\n@mixin sm {\n  @media (max-width: #{$screen-sm-max}) {\n    @content;\n  }\n}\n\n@mixin upToSm {\n  @media (min-width: #{$screen-sm-min}) {\n    @content;\n  }\n}\n\n// Medium devices\n@mixin md {\n  @media (min-width: #{$screen-md-min}) {\n    @content;\n  }\n}\n\n// Large devices\n@mixin lg {\n  @media (min-width: #{$screen-lg-min}) {\n    @content;\n  }\n}\n\n// Extra large devices\n@mixin xl {\n  @media (min-width: #{$screen-xl-min}) {\n    @content;\n  }\n}\n\n// Custom devices\n@mixin rwd($screen) {\n  @media (min-width: #{$screen}px) {\n    @content;\n  }\n}\n\n@mixin screnRange($min, $max) {\n  @media (min-width: #{$min}px) and (max-width: #{$max}px) {\n    @content;\n  }\n}\n\n@mixin screenHeightRange($min, $max) {\n  @media (min-height: #{$min}px) and (max-height: #{$max}px) {\n    @content;\n  }\n}\n","$text-primary: #ffffff;\n$primary-main: #FFEE20;\n$secondary-variant: #343434;\n$secondary-main: #1e1e1e;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
